// 页面JS逻辑文件
/* eslint-disable */
import Databus, { Origins } from "@ykz/ykz-http/core";
import {
  verifyPopularizer,
  getUserPromotion,
  pushSets,
  makeVisitorFans,
} from "@ykz/ykz-http/common";
import { buryingPoint } from "@/util/buryingPoint";
import ComponentAppDownload from "@/components/productDetail/app_download.vue";
import ComponentCustomerService from "@/components/productDetail/customer_service.vue";
import ComponentSetReminder from "@/components/productDetail/set_reminder.vue";
import ComponentTicketCalendar from "@/components/ticket_calendar.vue";
import ComponentProductPromotion from "@/components/productDetail/product_promotion.vue";
import ComponentVideoSale from "@/components/productDetail/video_sale.vue";
import ComponentTopicOffer from "@/components/productDetail/topic_offer.vue";
import ComponentRelatedRecommend from "@/components/productDetail/related_recommend.vue";
import ComponentEntranceRelatedRecommend from "@/components/productDetail/entrance_related_recommend.vue";
import ComponentPriceOther from "@/components/productDetail/price_other.vue";
import ComponentSelectStandard from "@/components/productDetail/select_standard.vue";
import ComponentRedpackFloat from "@/components/productDetail/redpack_float.vue";
import ComponentTaskEntry from "@/components/productDetail/task_entry.vue";
import ComponentScoreAddress from "@/components/productDetail/score_address.vue";
import ComponentAppPrice from "@/components/productDetail/app_price.vue";
import ComponentUserEvaluation from "@/components/productDetail/user_evaluation.vue";
import ComponentFloatUp from "@/components/productDetail/float_up.vue";
import ComponentShareType from "@/components/productDetail/share_type.vue";
import ComponentNavigationBtn from "@/components/productDetail/navigation_btn.vue";
import ComponentOpenApp from "@/components/productDetail/open_app.vue";
import ComponentNobrandPromotion from "@/components/productDetail/nobrand_promotion.vue";
import ComponentAutoRegister from "@/components/productDetail/auto_register.vue";
import ComponentEpidemicTips from "@/components/productDetail/epidemic_tips.vue";
import ComponentMushList from "@/components/productDetail/mush_list.vue";
import ComponentUseInstruction from "@/components/productDetail/use_instruction.vue";
import ComponentPlayGuide from "@/components/productDetail/play_guide.vue";
// import ComponentPurchaseProcess from "@/components/productDetail/purchase_process.vue";
import ComponentEnvelopeCoupon from "@/components/productDetail/envelope_coupon.vue";
import ComponentCouponReceive from "@/components/productDetail/coupon_receive.vue";
import ComponentPackageDetail from "@/components/productDetail/package_detail.vue";
import ComponentPreferentialInstruction from "@/components/productDetail/preferential_instruction.vue"; // 特殊说明单独模块
import ComponentSameRecommend from "@/components/productDetail/same_recommend.vue";
import StockDate from "@/components/productDetail/stock_date.vue";
import ComponentSelectOrderList from "@/components/productDetail/selected_order_list.vue";
import ComponentAddAppletTip from "@/components/add_applet_tip.vue";
import ComponentCommPersonalization from "@/components/productDetail/comm_personalization.vue";
import VideoSale from "@/components/productDetail/video_sale.vue";
// import LiveIcon from "@/components/productDetail/live_icon.vue";
import redpacketPopup from "@/components/redpacket_popup.vue";
import XGPlayer from "@/components/XGPlayer.vue";
import previewMedia from "@/components/previewMedia/index.vue";
import NoticeBar from "@/components/productDetail/notice_bar.vue";
import {
  updateUrlParam,
  initCountDown,
  showLoading,
  hideLoading,
  toast,
  toQueryString,
  pressEvent,
} from "@ykz/ykz-util/base";
import { isEmptyHtml } from "@ykz/ykz-util/base/validate";
import {
  isWX,
  isIos,
  isAndroid,
  isYkzMiniprogram,
  isYkzAlipayMiniprogram,
  isOtherBrowsers,
  copy,
  addQiniuParams,
  previewImage,
  goToHome,
  getQiNiuLazyImg
} from "@ykz/ykz-util/platform";

import { ex_getYCFLocInfo } from "../../../util/location";
import { lolila_2_nanuli_core } from "@/util/formatHtml";
import { lazyWithStr } from "../../../util/document";
let page = {
  name: "page",
  data() {
    return {
      notifications: [],
      kv: {
        goodsClassName: "",
        goodsSecondClassName: "",
        goodsThirdClassName: "",
        goodsFourthClassName: "",
        goodsLabelName: "",
      },
      magscenicDetail: null,
      isShowDownload: false,
      specialOperation: false,
      shareOrderList: [],
      checkInTime: getUrlParams("checkIn"),
      checkOutTime: getUrlParams("checkOut"),
      distributorName: getUrlParams("distributorName") || "",
      isFxb: getUrlParams("fxbInviteCode") || "",
      showDownloadTips: false, //app下载提示框
      showCheckRoot: false, //授权书弹框
      showOutAnimation: false, //展示关闭弹框动画
      isShowRedpackFloat: false, //助力红包浮层是否显示中，默认false
      showEnvelopeCoupon: false, // 是否展示优惠券红包弹窗
      redpackNum: 0, //返现红包数量
      isShowCustomer: false, //是否显示客服按钮
      isLevelBox: true, //会员等级弹框是否有显示，默认true
      isShowUserCoupon: -1, //是否进入页面就展示了新人专享券弹框，-1.还未通知   0.没有展示  1.有展示
      fromSource: getUrlParams("fromSource") || "", //来源
      weChatId: getUrlParams("weChatId") || window.weChatId,
      goodId: getUrlParams("goodId") || "", //商品id
      orderNo: getUrlParams("orderNo") || "", //订单号
      activityId: getUrlParams("activityId") || "", //活动id
      weChatType: window.comm.weChatType || 1, //1：直采和直销，2：市区娱乐(微商城)，3：渠道SIP直连，4：旅行社/综合类'(微商城)
      isOther: getUrlParams("isOther") || "", //非云客公众号直接通过链接访问所带的参数，用来隐藏二维码
      fromTopicId: getUrlParams("fromTopicId") || undefined, //专题页跳转到详情页所带的专题id
      rateplan: getUrlParams("rateplan") || "", //产品关联的价格计划
      shareIdKey: getUrlParams("shareIdKey") || "", //用户参与分享赚钱活动分享出来的加密串
      ajax_shareIdKey: "", //ajax返回生成的shareIdKey
      simData: getUrlParams("simData") || "", //模拟假数据的参数
      isGuide: false, //是否需要显示引导指示，针对微信公众号发的部分商品链接
      isPoint: false, //是否需要显示引导指示，针对注册后首次进入商城的推广员

      isAPP: window.mobileEnv == "app" ? true : false, //是否在云客赞app打开页面
      isIos: isIos(), //设备系统
      isTourist: window.isTourist, //是否是游客身份
      isReviewing: false, //iOS审核判断,默认false
      isWxInstalled: window.mobileEnv == "app" ? false : true, //用户设备是否有安装微信
      isMini: isYkzMiniprogram(), //是否在微信小程序打开页面
      isAlipayMini: isYkzAlipayMiniprogram(),
      isOtherBrowser: isOtherBrowsers(), //除微信、app外的第三方浏览器打开页面
      isShop:
        sessionStorage.getItem("session_isShop") ||
        getUrlParams("isShop") ||
        "", //店铺模式
      isShopKeeper:
        (!getUrlParams("orderNo") &&
          (sessionStorage.getItem("session_isShop") ||
            getUrlParams("isShop")) &&
          sessionStorage.getItem("is_shop_keeper")) ||
        "", //有值时表示店长是从自己店铺过来的，交易快照模式不兼容
      isPullNew: getUrlParams("isPullNew") || "", //商品拉新模式

      isTicket: false, //是否为票券产品，默认false
      isShowTicket: false, //是否为演出票产品，默认false
      isEntranceTicket: false, //是否为新门票产品，默认false
      isMultipleDetails: false, //是否为多产品门票集合模式
      isRoom:
        (getUrlParams("isRoom") &&
          location.href.search("index/entranceTicketDetails") != -1) ||
        false, //是否为活动微客房详情页
      isSpecialty: location.href.search("index/specialDetails") != -1, //是否为特产详情页
      isAuto: false, //除了特产自适应高度

      timeObj: {}, //倒计时对象
      millisecond: 0, //倒计时毫秒数
      queueStatus: 1, //0:未开始，1：进行中，2：已结束
      couponDetail: {}, //详情，接口返回
      roomDetails: {}, //房型信息，接口返回
      promoter: {}, //推广员信息
      promoterGroup: {}, //推广员群信息

      standardList: {}, //存放改造后的that.couponDetail.standardList,standard数组改成对象,其id属性为键,加快索引
      priceAndStockNum: {}, //存放改造过的数据，specIdKey值当做键，加快索引速度
      specIdKey: "", //选中项目规格对应的索引值（priceAndStockNum列表的索引值）
      isMultiPrice: false, //是否属于多价格产品，默认false
      standardTxt: "", //规格文案
      packageName: "", //所选择的套餐产品名称
      canBuy: -1, //用户可购买数，默认不限
      priceTxtArr: [], //售价

      soldMsgData: [], //已购买用户信息
      soldMsgIndex: 0, //已购买用户信息滚动指示器
      isShowSoldMsg: true, // 是否显示已购买用户信息滚动模块
      soldeMsgClass: "", //已购买用户信息动画样式
      soldeMsgJob1: {}, //已购买用户信息循环事件
      soldeMsgJob2: {}, //已购买用户信息循环事件

      isShowGoTop: false, // 是否显示返回顶部按钮
      goTopClass: "", // 返回顶部按钮样式

      isOnline: true, //是否上线，默认上线
      isExpired: false, //产品失效的
      buyBtnTxt: "立即抢购", //购买按钮文案
      validityTxt: "", //有效期文案，如：2017-10-18至2018-01-02,2018-02-12前有效，24小时后生效
      albumUrl: [], // 需要预览的图片http链接列表
      paused: true, //相册视频是否停止播放，默认true
      isRateplan: false, //该产品是否有关联价格计划，默认false
      useCoupon: 1, //是否可使用现金券，默认1
      useCloudCoin: 1, //是否可使用云币，默认1

      password: "", //商品口令
      passwordGenerated: false, //商品口令生成完成（可生成失败）
      posterLink: "", //生成海报图所需的链接
      shareLink: "", //分享链接，用于转化成短链接

      isMaterialExists: 0, //素材是否存在（1存在，0不存在）
      isRecommendExists: 1, //商品推荐是否存在（1存在，0不存在)
      selectedTab: 0, //已选择的tab，-1.未选中显示状态 0.隐藏状态  1.商品  2.素材 3.须知  4.详情 5.推荐
      offsetY: 0, //top-bar的Y轴偏移量

      promotionCity: {}, // 商品推荐需要的地址
      relationType: null,
      relationTypeId: null,

      ABTest: {}, //ABtest实验， http://jira.yaochufa.com:8080/browse/DVB-18703
      sameRecommendList: [], // 同类型产品列表
      hasCoupon: false,
      coin: {}, // 用户的红包相关对象
      couponList: [], // 优惠券列表
      remainSeconds: 0, // 剩余秒数
      purchaseNotesExpand: true,
      showGraphicDetail: true,

      activityId: 0,
      gpsData: {},
      hasPopup: 0, // 1显示 0不显示
      activityInfo: {}, // 活动信息
      x0: 0,
      y0: 0,
      hasmoved: 0,
      lock: 0,
      showVideoSale: false, // 是否显示视频号带货弹窗

      screenHeight: window.innerHeight, // 当前屏幕高度
      commentInfos: null,

      officialTabs: [],
      officialAlbum: [],
      bannerIndex: 0,
      // 轮播图配置
      swiperOptions: {
        loop: false,
        autoHeight: true,   // 启用自动高度
        slidesPerView: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        onSlideChangeEnd: swiper => {
          this.onSlideChangeEnd(swiper);
        },
      },
      mySwiper: null,
      bannerList: [],
      navList: [], // banner导航
      autoPlay: false, //是否自动播放
      showCoverImg: false, // 是否显示封面 一般只显示一次
      xgplayer: null,
      showStartBtn: false,
      showStopBtn: true,
      pauseIcon: 'https://qiniu-cdn6.jinxidao.com/group1/2025/01/16/15/36/596036788b6ed5854a.png',
      playIcon: 'https://qiniu-cdn7.jinxidao.com/wxProgram/images/zby/play_big_icon.png',
      isPreviewVisible: false,
      currentIndex: 0,
      mediaList: [],

      bannerLazyImg: 'https://qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_750_750.png'
    };
  },

  filters: {
    //图片链接增加七牛图片处理参数
    filterImgLink(value, isNew, isHotelRoom) {
      return addQiniuParams(
        value,
        // isHotelRoom
        //     ? "?imageView2/2/interlace/1/q/85"
        //     : isNew
        //     ? "?imageView2/1/w/800/interlace/1/q/85/"
        //     : "?imageView2/2/w/750/interlace/1/q/85/",
        // 下面这个format格式不能转成jpg，因为可能是动图，也不能转成webp，因为ios微信小程序可能不支持
        "?imageMogr2/format/jpg/interlace/1/thumbnail/750x/crop/x750/quality/55",
        "//qiniu-cdn7.jinxidao.com/dvb/frontv2/images/loading_img_750_750.png"
      );
    },
    //推广人数过滤器
    filterShareNum(val) {
      val = Number(val);
      if (val) {
        if (val >= 10000) {
          return Math.floor((val / 10000) * 10) / 10 + "万";
        } else {
          return val;
        }
      } else {
        return 0;
      }
    },
    textFilter: function (coupon) {
      if (coupon.amountType === "fixed") {
        var text1 = (parseFloat(coupon.amountAttr.amount) / 100).toFixed(1);
        return coupon.lowerLimit == 0
          ? "立减" + text1
          : "满" +
          (parseFloat(coupon.lowerLimit) / 100).toFixed(1) +
          "减" +
          text1;
      } else {
        var str = coupon.amountAttr.discount.toString().split(".")[1],
          text2 = str[0] + "." + (str[1] ? str[1] : "0") + "折";
        return coupon.lowerLimit == 0
          ? "无门槛" + text2
          : "满" +
          (parseFloat(coupon.lowerLimit) / 100).toFixed(1) +
          "元" +
          text2;
      }
    },
    dateFormat: function (timestamp) {
      // var nowYear = new Date(timestamp * 1000).getFullYear();
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "年";
      var M = date.getMonth() + 1 + "月";
      var D = date.getDate() + "日";

      return Y + M + D;
    },
  },
  computed: {
    showReward() {
      let appSellComm = this.promoter.appSellComm;
      let renderAppSellCommon = true;
      if (appSellComm == "") {
        renderAppSellCommon = false;
      } else if (appSellComm.includes("%")) {
        // 百分比奖励暂不显示
        renderAppSellCommon = false;
      } else if (appSellComm.search(/￥|¥/) !== -1) {
        appSellComm = appSellComm.replace(/￥|¥/, "");
        // 转换为浮点数并验证
        if (parseFloat(appSellComm) > 0) {
          console.log("appSellComm 有效:", appSellComm);
        } else {
          renderAppSellCommon = false;
        }
      }
      return renderAppSellCommon;
    },

    //计算省多少钱(包括红包)
    getSaveMoney: function () {
      let comm = "";
      if (this.promoter.isExcellence) {
        comm = this.isAPP
          ? this.promoter.appSellComm || this.promoter.sellComm
          : this.promoter.sellComm;
      } else {
        comm = this.isAPP
          ? this.promoter.originalAppSellComm || this.promoter.originalSellComm
          : this.promoter.originalSellComm;
      }
      if (typeof comm != "string") {
        return this.redpackNum;
      } else {
        var saveMoney = 0;
        if (comm.search("%") != -1) {
          saveMoney =
            Math.round(
              (((this.activityId
                ? this.couponDetail.activityPrice
                : this.couponDetail.sellPrice) *
                (+comm.replace(/[^0-9|.]/g, "") || 0)) /
                100 +
                this.redpackNum) *
              100
            ) / 100;
        } else if (comm.search(/[￥|¥]/) != -1) {
          saveMoney =
            Math.round(
              ((+comm.replace(/[^0-9|.]/g, "") || 0) + this.redpackNum) * 100
            ) / 100;
        }
        console.log(saveMoney, "saveMoneysaveMoney");
        return saveMoney;
      }
    },

    //计算省多少钱(不包括红包)
    getSaveMoneyForPullNew: function () {
      let comm = "";
      if (this.promoter.isExcellence) {
        comm = promoter.appSellComm || promoter.sellComm;
      } else {
        comm = promoter.originalAppSellComm || promoter.originalSellComm;
      }
      if (typeof comm != "string") {
        return "¥0.00";
      } else {
        var saveMoney = 0;
        if (comm.search("%") != -1) {
          saveMoney =
            Math.round(
              (((this.activityId
                ? this.couponDetail.activityPrice
                : this.couponDetail.sellPrice) *
                (+comm.replace(/[^0-9|.]/g, "") || 0)) /
                100) *
              100
            ) / 100;
        } else if (comm.search(/[￥|¥]/) != -1) {
          saveMoney =
            Math.round((+comm.replace(/[^0-9|.]/g, "") || 0) * 100) / 100;
        }
        return "¥" + saveMoney.toFixed(2);
      }
    },
    isActivity: function () {
      return Boolean(this.activityId);
    },
    renderReserveStock: function () {
      return (
        !this.orderNo &&
        this.couponDetail.isSupportOnlineReserve == 1 &&
        (this.couponDetail.isBookStock == 2 ||
          (this.couponDetail.additionalType == 2 &&
            this.couponDetail.jointCardBookUrls))
      );
    },
    orderRuleTime: function () {
      return JSON.parse(this.couponDetail.orderRuleTime);
    },
    /**
     * 右下角推广按钮奖励展示
     */
    promotionComm() {
      let comm = "";
      if (this.promoter.isExcellence) {
        comm = this.isAPP ? this.promoter.appSellComm : this.promoter.sellComm;
      } else {
        comm = this.isAPP
          ? this.promoter.originalAppSellComm
          : this.promoter.originalSellComm;
      }
      return comm;
    },
    // 补差价说明根据 换行符
    farePolicyStr() {
      return (
        this.couponDetail.farePolicy && this.couponDetail.farePolicy.split("\n")
      );
    },
    farePplicyLabel() {
      const addFareType = ~~this.couponDetail.addFareType;

      if (addFareType === 1) {
        return "周末不加价";
      } else if (addFareType === 2) {
        return "节假日不加价";
      } else {
        return "";
      }
    },
    // 有效期展示处理
    validityDesc() {
      let vDesc = "";
      const cateId = ~~this.couponDetail.cateId;
      const isCalendar = ~~this.couponDetail.isCalendar;
      const calendarMode = ~~this.couponDetail.calendarMode;
      const changeCalendar = this.couponDetail.changeCalendar;
      const effectiveTime = ~~this.couponDetail.effectiveTime || 0;
      const ineffectiveTime = ~~this.couponDetail.ineffectiveTime || 0;
      const calendarUseStartTime =
        ~~this.couponDetail.calendarUseStartTime || 0;
      const calendarUseEndTime = ~~this.couponDetail.calendarUseEndTime || 0;
      const newTicketEffectiveTime =
        this.couponDetail.newTicketEffectiveTime || 0;
      const isNewGlobalSale = this.couponDetail.isNewGlobalSale || 0;
      const ineffectiveDay = this.couponDetail.ineffectiveDay || "";
      if (cateId == 8 && newTicketEffectiveTime > 0) {
        vDesc = `购买${newTicketEffectiveTime}分钟后生效，`;
      }
      if (isCalendar === 1 && changeCalendar === "0") {
        // 前端日历模式，显示指定文案
        vDesc = `${vDesc}预定的日期当天有效`;
      } else if (isCalendar == 0) {
        if (isNewGlobalSale == 1 && ineffectiveDay != "") {
          vDesc = ineffectiveDay;
        } else {
          // 非日历模式
          vDesc = `${vDesc}${this.transformTime(
            effectiveTime
          )}至${this.transformTime(ineffectiveTime)}`;
        }
      } else if (
        isCalendar === 1 &&
        changeCalendar == "1" &&
        calendarUseStartTime &&
        calendarUseEndTime
      ) {
        // 后端日历模式，前端非日历
        vDesc = `${vDesc}${this.transformTime(
          calendarUseStartTime
        )}至${this.transformTime(calendarUseEndTime)}`;
      }
      return vDesc;
    },


  },
  methods: {
    //图片懒加载
    getLazyImg: function (img, lazyUrl) {
      return getQiNiuLazyImg(img, '', '', lazyUrl)
    },

    handleShowVideoSaleDialog() {
      this.showVideoSale = true;
    },
    getShareOrder() {
      const that = this;
      Databus({
        url: "/api/shareOrder/index",
        origin: Origins.API_MARKETING,
        data: {
          page: 1,
          pageSize: 4,
          latFixed: "",
          lngFixed: "",
          cityName: "",
          goodId: this.goodId,
        },
        success: function (data) {
          if (data.code == 1000 && data.bcode == 100 && data.content) {
            if (data.content.list && data.content.list.length > 4) {
              that.shareOrderList = data.content.list.slice(0, 4);
            } else {
              that.shareOrderList = data.content.list;
            }
          }
        },
        beforeSend: function () {
          showLoading();
        },
        complete: function () {
          hideLoading();
        },
        error: function () {
          toast("网络有问题，请重试");
        },
      });
    },

    // 初始化购买须知/图文详情折叠
    initExpand() {
      this.$nextTick(() => {


        // 判断购买须知是否需要收起 purchaseNotesExpand=fasle(收起)
        if (this.getElementHeight('purchaseNoticeContent') > 222 && this.couponDetail.isPurchaseNoticeFold) {
          this.purchaseNotesExpand = false;
        } else {
          this.purchaseNotesExpand = true;
        }


        this.waitForImagesToLoad().then(() => {
          const height = this.$refs.graphicDetailContent.offsetHeight;
          // 判断是否折叠图文详情
          if (height > window.innerHeight) {
            this.showGraphicDetail = false
          } else {
            this.showGraphicDetail = true
          }

          if (this.couponDetail.imageTextVideoAutoPlay == '1') {
            setTimeout(() => {
              $(".rich-text video").each(function () {
                const $video = $(this);
                $video.prop("muted", true); // 设置静音

                // 先暂停，确保视频的状态是暂停的
                this.pause();
                this.play();
                // 使用 bind() 确保 `this` 指向视频元素
                // $(this).on('loadeddata', function () {
                //   console.log('视频已加载数据');
                //   // 视频数据加载完成后播放
                //   this.play().catch((err) => {
                //     console.log("播放失败", err);
                //   });
                // }.bind(this)); // 确保 this 指向当前的 video 元素

                // 针对微信环境的处理逻辑
                if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
                  WeixinJSBridge.invoke("getNetworkType", {}, () => {
                    this.play();
                  });
                }

                document.addEventListener("WeixinJSBridgeReady", () => {
                  this.play();
                }, false);
              });

            }, 1000);
          }

        });



      })
    },

    waitForImagesToLoad() {
      return new Promise((resolve) => {
        const images = this.$refs.graphicDetailContent.querySelectorAll('img');
        let loadedCount = 0;

        if (images.length === 0) {
          resolve(); // 没有图片，直接完成
          return;
        }

        images.forEach((img) => {
          if (img.complete) {
            loadedCount++;
            if (loadedCount === images.length) {
              resolve(); // 所有图片已加载完成
            }
          } else {
            img.onload = img.onerror = () => {
              loadedCount++;
              if (loadedCount === images.length) {
                resolve(); // 所有图片已加载完成或加载失败
              }
            };
          }
        });
      });
    },
    getElementHeight(elName) {
      return this.$refs[elName].offsetHeight || 0;
    },
    viewReport() {
      let shareUserId = window.getUrlParams("userId") || "";
      if (!shareUserId) return;
      Databus({
        type: "post",
        url: "/api/freshShareOut/viewReport",
        origin: Origins.API_MARKETING,
        data: {
          shareUserId,
        },
        success: function (res) { },
      });
    },
    transformTime(timestamp) {
      const date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const Y = date.getFullYear() + "年";
      const M = date.getMonth() + 1 + "月";
      const D = date.getDate() + "日";

      return Y + M + D;
    },
    handleTouchstart(e) {
      let touch = e.targetTouches[0],
        x = touch.pageX,
        y = touch.pageY;

      this.x0 = x;
      this.y0 = y;
      this.hasmoved = 0;
      this.lock = 0;
    },


    expandAll: function () {
      this.purchaseNotesExpand = true;
    },
    expandGraphicDetailAll() {
      this.showGraphicDetail = true;
    },
    openReserveUrl: function () {
      if (this.isMini) {
        toast("小程序无法直接打开外部链接，可一键复制后，再通过手机浏览器打开");
        return;
      }
      window.location.href = this.couponDetail.reserveUrl || "";
    },
    copyReserveUrl: function () {
      const code = this.couponDetail.reserveUrl || "";
      copy(code)
        .success(function () {
          toast("复制成功");
        })
        .fail(function () {
          toast("您的设备不支持一键复制功能，请长按选择订单编号进行复制");
        });
    },
    titleLabel: function (str) {
      const len = str.length || 0;
      return `p-${len}`;
    },
    // 初始化数据
    initCouponList: function () {
      if (this.goodId && !this.orderNo && !this.isReviewing) {
        this.getCouponList(this.goodId);
      } else {
        return;
      }
    },
    //获取用户红包数量
    getUserCoinInfo: function () {
      var that = this;
      Databus({
        url: "/api/yuncoin/getUserCoinInfo",
        type: "get",
        origin: Origins.API_ACT,
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.coin = res.content || {};
          }
        },
      });
    },
    getStamps: function () {
      var that = this;
      Databus({
        type: "get",
        url: "/apiv2/goods/getStamps",
        data: {
          goodsId: this.goodId,
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            if (res.content && res.content.category) {
              if (res.content.category[0]) {
                that.kv.goodsClassName = res.content.category[0].stampName;
              }
              if (res.content.category[1]) {
                that.kv.goodsSecondClassName =
                  res.content.category[1].stampName;
              }
              if (res.content.category[3]) {
                that.kv.goodsThirdClassName = res.content.category[3].stampName;
              }
              if (res.content.category[4]) {
                that.kv.goodsFourthClassName =
                  res.content.category[4].stampName;
              }
              that.kv.goodsLabelName = res.content.labels
                .map((obj) => {
                  return obj.stampName;
                })
                .join(",")
                .split(",");
              buryingPoint("SXY-LLSXY", "浏览商详页", that.kv);
            }
          } else {
            console.log(res.message);
          }
        },
      });
    },
    //获取数据
    getCouponList: function (goodId) {
      var that = this;

      Databus({
        type: "get",
        url: "/api/activity/getCouponListWithGoods",
        origin: Origins.API_ACT,
        data: {
          goodsId: goodId,
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            var result = res.content;
            if (result && result.length > 0) {
              that.hasCoupon = true;
              that.couponList = extendList(result);
              that.isHasAssignedCoupon();
              // that.generatedList();
            } else {
              that.couponList = [];
            }
          } else {
            console.log(res.message);
          }
        },
      });

      // 添加isShowIntro属性
      function extendList(list) {
        var newList = [];

        for (var i = 0; i < list.length; i++) {
          var item = list[i],
            j = item.assignNum;
          item.isShowIntro = false;

          while (j > 0) {
            var newItem1 = JSON.parse(JSON.stringify(item));
            newItem1.coupoNum = 0;
            newItem1.assignNum = 1;
            newItem1.hasAssigned = 1;
            newList.push(newItem1);
            j--;
          }
          if (item.coupoNum > 0) {
            var newItem2 = JSON.parse(JSON.stringify(item));
            newItem2.hasAssigned = 0;
            newItem2.assignNum = 0;
            newList.push(newItem2);
          }
        }

        return newList;
      }
    },

    // 是否有未领取券
    isHasAssignedCoupon: function () {
      if (this.couponList && this.couponList.length > 0) {
        var flag = this.couponList.some(function (item) {
          return item.hasAssigned === 0;
        });
        flag ? (this.showType = 1) : (this.showType = 2);
      } else {
        this.showType = 3;
      }
    },
    // 显示红包领券弹窗
    showEnvelopeCouponsLayer: function () {
      // componentCenter.envelopeCoupon.slideUpEnvelopeCoupon();
      componentCenter.couponReceive.slideUpEnvelopeCoupon();
    },
    //toast
    toast: function (str) {
      toast(str);
    },

    //Loading
    showLoading: function (toastText) {
      showLoading({
        cover: true,
        opacity: 0,
        toastText: toastText,
      });
    },

    //大数据锚点
    reportUserAnchors: function (event_id, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: event_id,
        event_content: {
          item_id: this.goodId,
        },
      }).always(callback);
    },

    //通用锚点事件
    generalAnchors: function (element_content, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: "520006",
        properties: {
          element_content: element_content,
          item_id: this.goodId,
        },
      }).always(callback);
    },

    //跳转商家资质
    handelViewBusiness: function () {
      window.location.href =
        "/front/index/businessLicense?" +
        toQueryString({
          weChatId: this.weChatId,
          fromWeChatId: this.fromWeChatId,
          simData: this.simData || null,
          goodId: this.couponDetail.goodId,
        });
    },

    //打开地图导航
    gotoNav: function () {
      ///TLH220921

      componentCenter.scoreAddress && componentCenter.scoreAddress.gotoNav();
    },

    //跳转到话题页
    goTopicListPage: function (topic) {
      var that = this;
      this.generalAnchors("clickTalk", function () {
        window.location.href =
          "/front/index/topicList?" +
          toQueryString({
            weChatId: that.weChatId,
            topicTagId: topic.topicTagId,
            topicType: topic.topicType,
            tagType: topic.tagType,
            productType: topic.productType,
            topicName: encodeURIComponent(topic.topicName),
            addressType: topic.addressType,
            addressName: encodeURIComponent(topic.addressName),
            simData: that.simData,
          });
      });
      // 用户点击某tag
      // this.newAnchorPoint("点击商详TAG", topic.topicName);
    },

    //跳转到首页
    goHomePage: function (event_id) {
      buryingPoint("SXY-DJSY", "点击首页", this.kv);
      if (this.orderNo) return;
      var that = this;
      that.reportUserAnchors(event_id, function () {
        if (that.isAPP) {
          ykzApp.ready(function () {
            ykzApp.toAppIndex &&
              ykzApp.toAppIndex({
                hash: "1",
              });
          });
        } else if (that.isFxb) {
          window.location.href =
            "/front/promoter/fxbIndex?weChatId=1&fromWeChatId=" + that.weChatId;
        } else if (that.isShop) {
          window.location.href =
            "/front/promoter/myShop?weChatId=" +
            that.weChatId +
            "&promotion=" +
            (sessionStorage.getItem("isShop_promotion") || "");
        } else if (that.weChatType == 1 && !that.isShowTicket) {
          window.location.href =
            "/front/index/indexNew?weChatId=" + that.weChatId;
        } else {
          window.location.href =
            "/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=" +
            that.weChatId;
        }
      });
    },

    //跳转到素材页
    goMaterialPage: function () {
      var that = this;
      this.generalAnchors("clickMaterial", function () {
        window.location.href =
          "/front/promoter/material?weChatId=1&fromWeChatId=" +
          that.weChatId +
          "&goodId=" +
          that.goodId +
          (that.simData ? "&simData=1" : "");
        // if(that.isAPP) {
        // 	ykzApp.ready(function() {
        // 		if(ykzApp.showMaterialPage) {
        // 			ykzApp.showMaterialPage({
        // 				goodId: that.goodId,
        // 				activityId: that.activityId + "",
        // 				productName: that.couponDetail.goodsAlias || that.couponDetail.goodsName,
        // 				attachUrl: that.couponDetail.coverPic,
        // 				city: that.couponDetail.city || "",
        // 				minPrice: that.activityId ? that.couponDetail.activityPrice : that.couponDetail.sellPrice,
        // 				sellComm: that.promoter.isShare ? (that.promoter.appSellComm || that.promoter.sellComm) : "",
        // 				isMultiSpec: Object.getOwnPropertyNames(that.priceAndStockNum).length > 2 ? true : false,
        // 				startTime: that.couponDetail.queueStartTime || 0,
        // 				endTime: that.couponDetail.queueEndTime || 0,
        // 				isActivity: Boolean(that.activityId)
        // 			});
        // 		} else {
        // 			that.showDownloadTips = true;
        // 		}
        // 	});
        // } else {
        // 	window.location.href = "/front/promoter/material?weChatId=1&fromWeChatId=" + that.weChatId + "&goodId=" + that.goodId + (that.simData ? "&simData=1" : "");
        // }
      });
    },

    //显示收入说明弹框
    showIncomeStatement: function (updateDate) {
      componentCenter.incomeStatement.slideUpIncomeStatement({
        updateDate: updateDate || false,
        goodId: this.goodId,
        price: this.activityId
          ? this.couponDetail.activityPrice
          : this.couponDetail.sellPrice,
        sellComm: this.promoter.sellComm,
        appSellComm: this.promoter.appSellComm,
        originalSellComm: this.promoter.originalSellComm,
        originalAppSellComm: this.promoter.originalAppSellComm,
        isHaveFans: this.promoter.isHaveFans,
        isMultipleCommission: this.promoter.isMultipleCommission,
        isAppMultipleCommission: this.promoter.isAppMultipleCommission,
        isOpenMemberCommission: this.promoter.isOpenMemberCommission,
        memberLevel: this.promoter.memberLevel,
        memberReward: this.promoter.memberReward,
        memberRewardMoney: this.promoter.memberRewardMoney,
        isGoodPromoter: this.promoter.hasTeamPrivilege == 5,
        isNewPromoter: this.promoter.isNewPromoter,
        hasTeamPrivilege: this.promoter.hasTeamPrivilege,
        commReturnType: this.couponDetail.commReturnType,
        isExcellence: this.promoter.isExcellence,
        /**
         * 奖励个性化展示
         * commShowType = 1;//个性化展示（普通云客展示普通云客奖励，优秀云客展示优秀云客奖励）
         * commShowType = 2;//列表展示高佣，商详展示实际奖励
         */
        promoter: this.promoter,
        commShowType: this.promoter.commShowType,
        agencyComm: this.promoter.agencyComm || "",
        appAgencyComm: this.promoter.appAgencyComm || "",
        goodComm: this.promoter.goodComm || "",
        maxCommission: this.promoter.maxCommission,

        nowLevelSellComm: this.promoter.promoterLevel.nowLevelSellComm,
        nowLevelAgencyComm: this.promoter.promoterLevel.nowLevelAgencyComm,
        toLevelNoString: this.promoter.promoterLevel.toLevelNoString,
        nowLevelNo: this.promoter.promoterLevel.nowLevelNo,
        toLevelSellComm: this.promoter.promoterLevel.toLevelSellComm,
        toLevelAgencyComm: this.promoter.promoterLevel.toLevelAgencyComm,
      });
      // 点击收入说明， 埋点
      // this.newAnchorPoint("点击商详", "收入说明");
    },

    //显示授权书弹框
    loadCheckRroot: function () {
      if (!this.couponDetail.hotelCertificate) {
        return false;
      }
      if (this.checkRootAppendImg) {
        this.showCheckRoot = true;
        return true;
      }
      this.showLoading();
      var img = new Image();
      var that = this;
      img.src = this.couponDetail.hotelCertificate;
      img.onload = function () {
        $(".check-root-box .main-content").append(img);
        that.checkRootAppendImg = true; //图片加载完成
        that.showCheckRoot = true;
        that.$nextTick(function () {
          hideLoading();
        });
      };
      img.onerror = function () {
        hideLoading();
        that.toast("授权书加载失败，请刷新页面重试");
      };
    },

    //隐藏授权书弹框
    hideBox: function () {
      var that = this,
        timer = null;
      this.showOutAnimation = true;
      timer = setTimeout(function () {
        clearTimeout(timer);
        that.showOutAnimation = false;
        that.showCheckRoot = false;
      }, 200);
    },

    //向上滑动显示规格弹框
    slideUpSpecification: function () {
      if (
        this.isMultipleDetails &&
        (Object.getOwnPropertyNames(this.standardList).length == 1 ||
          Object.getOwnPropertyNames(this.priceAndStockNum).length == 1)
      ) {
        console.log("多产品类型未封装成多规格数据");
        this.toast("套餐不存在！");
        return false;
      }
      componentCenter.selectStandard.slideUpSpecification();
    },

    //显示客服
    showCustomerService: function () {
      buryingPoint("SXY-DJZXKF", "点击咨询客服", this.kv);
      YCF_Plugin.anchorPoint(
        "商品页客服",
        "gooddetail_customer",
        `goodId:${this.goodId}`
      );
      if (this.orderNo) return;
      var that = this;
      this.generalAnchors("clickCustomerService", function () {
        componentCenter.customerService.loadOrShowCustomerService();
      });
    },

    //查看预约库存
    viewReserveStock: function () {
      if (this.couponDetail.additionalType == 2) {
        window.location.href = this.couponDetail.jointCardBookUrls;
      } else {
        componentCenter.ticketCalendar.viewReserveStock(this.goodId);
      }

      YCF_Plugin.anchorPoint(
        "商品（预售产品）页可约日期",
        "gooddetail_appointment_information",
        `goodId:${this.goodId}`
      );
    },

    //显示产品分享或分享弹框或跳转到注册页
    showProductPromotion(str) {
      let that = this;
      buryingPoint("SXY-DJTGHB", "点击推广/海报", that.kv);
      YCF_Plugin.anchorPoint(
        "商品页下面的分享",
        "gooddetail_down_share",
        `goodId:${this.goodId}`
      );
      YCF_Plugin.reportUserAnchors({
        event_id: "500128",
        event_content: {
          item_id: this.goodId,
        },
        properties: {
          item_id: this.goodId,
          is_test: this.ABTest.isAvailGoods, //是否开启ABtest
          group: this.ABTest.isAvailGoods
            ? this.ABTest.userType == 1
              ? "A"
              : "B"
            : undefined, //A组或B组
        },
      }).always(() => {
        if (that.promoter.registerEntrance) {
          window.location.href =
            "/front/promoter/inviteC?weChatId=1&fromWeChatId=" +
            that.weChatId +
            "&registSource=9";
        } else {
          if (
            !that.isAPP &&
            !str &&
            that.promoter.isOpenShop &&
            !that.hasSetShopCollection
          ) {
            that.setShopCollection();
          }
          componentCenter.productPromotion.showShare(that, str);
        }
      });
    },
    // 点击商品tab
    goToGoodsPosition: function () {
      this.scrollOffsetTop(".scroll-area"),
        this.generalAnchors("clickProductNavigation"),
        buryingPoint("SXY-DJDHTABSP", "点击导航tab-商品", this.kv);
    },
    // 点击详情tab
    goToDetailPosition: function () {
      this.scrollOffsetTop(
        ".detail-txt" + (this.isSpecialty ? "" : ".graphic-detail")
      ),
        this.generalAnchors("clickDetailNavigation"),
        buryingPoint("SXY-DJDHTABXQ", "点击导航tab-详情", this.kv);
    },
    // 点击评论tab
    goToCommentPosition: function () {
      this.scrollOffsetTop("#component-user-evaluation"),
        this.generalAnchors("clickCommentNavigation"),
        buryingPoint("SXY-DJDHTABPL", "点击导航tab-评论", this.kv);
    },
    // 点击须知tab
    goToPurchaseNotestPosition: function () {
      this.scrollOffsetTop(".detail-txt.purchase-notes"),
        this.generalAnchors("clickNoticeNavigation"),
        buryingPoint("SXY-DJDHTABXZ", "点击导航tab-须知", this.kv);
    },
    // 点击推荐tab
    goToRecommendPosition: function () {
      this.scrollOffsetTop(".cmp-promotion"),
        this.generalAnchors("clickRecommendNavigation"),
        buryingPoint("SXY-DJDHTABTJ", "点击导航tab-推荐", this.kv);
      YCF_Plugin.anchorPoint(
        "商品页大家都在去",
        "gooddetail_recommend",
        `goodId:${this.goodId}`
      );
    },
    //滚动到指定位置，target目标元素名称(String类型)，scroll滚动元素的名称(String类型)，offset偏移量(int类型)
    scrollOffsetTop: function (target, scroll, offset) {
      console.log("scroll......", target, scroll, offset);
      if (typeof target != "string" || !$(target)[0]) {
        return false;
      }
      $(scroll || ".scroll-area").animate(
        {
          scrollTop:
            $(target)[0].offsetTop -
            (typeof offset == "undefined"
              ? $(".top-bar")[0]
                ? $(".top-bar")[0].offsetHeight
                : 0
              : offset),
        },
        250
      );
    },

    //初始化倒计时
    initCountDown: function () {
      if (this.couponDetail.statusIs == 2) {
        this.queueStatus = 2;
        return false;
      }
      var that = this,
        couponDetail = this.couponDetail,
        serverTimeStamp = couponDetail.serverTimeStamp,
        queueStartTime = couponDetail.queueStartTime,
        queueEndTime = couponDetail.queueEndTime,
        rsecond = 0,
        milliJob;
      if (serverTimeStamp < queueStartTime) {
        //未开始
        this.queueStatus = 0;
        rsecond = queueStartTime - serverTimeStamp;
      } else if (
        serverTimeStamp >= queueStartTime &&
        serverTimeStamp <= queueEndTime
      ) {
        //进行中
        this.queueStatus = 1;
        rsecond = queueEndTime - serverTimeStamp;
      } else {
        //已结束
        this.queueStatus = 2;
        this.isInitialEnd = true; //标记一开始活动就已经结束了
        rsecond = 0;
      }
      this.remainSeconds = rsecond;
      initCountDown({
        rsecond: rsecond,
        fn_cdIng: function (timeObj) {
          that.timeObj = timeObj;

          //模拟毫秒倒计时，精确到百分位
          clearInterval(milliJob);
          milliJob = setInterval(function () {
            var num = that.millisecond || 0;
            num -= 1;
            if (num == -1) {
              num = 9;
            }
            that.millisecond = num;
          }, 100);

          if (that.queueStatus == 0) {
            if (
              that.isShop ||
              (timeObj.day == 0 &&
                timeObj.hour == 0 &&
                (timeObj.minute < 5 ||
                  (timeObj.minute == 5 && timeObj.second == 0)))
            ) {
              that.buyBtnTxt = "即将开抢";
            } else {
              that.buyBtnTxt = that.couponDetail.isSetRemind
                ? "取消提醒"
                : "设置提醒";
            }
          }
          if (that.queueStatus == 1) {
            that.couponDetail.stockShow != 2 && (that.buyBtnTxt = "立即抢购");
          }
          if (that.isShopKeeper) that.buyBtnTxt = "推广";
        },
        fn_cdEnd: function (timeObj) {
          console.log("倒计时完成");
          that.timeObj = timeObj;
          clearInterval(milliJob);
          that.millisecond = 0;
          if (that.queueStatus == 0) {
            that.couponDetail.serverTimeStamp =
              that.couponDetail.queueStartTime;
            that.initCountDown();
          } else if (that.queueStatus == 1 || that.queueStatus == 2) {
            that.couponDetail.stockShow != 2 && (that.buyBtnTxt = "已结束");
            that.queueStatus = 2;
            that.isOnline = false;
            !that.isInitialEnd &&
              componentCenter.relatedRecommend.slideUpRecommendBox();
          }
        },
      });
    },
    // 点击商详页顶部轮播图
    clickSwiper: function (index) {
      // 只有点击主图才统计
      if (index === 0) {
        // this.newAnchorPoint("点击商详", "主图");
      }
    },
    //获取产品详情
    async getProductDetail() {
      let that = this,
        isReGetProductDetail = false, //是否需要重新调用产品详情接口，链接有误导致接口调用错误时需要
        temp = {}; //ajax的url和data
      if (this.orderNo) {
        temp.url = "/apiv2/order/orderSnaps";
        temp.data = {
          orderNo: this.orderNo,
          isShop: this.isShop,
        };
      } else if (this.isRoom) {
        // 微客房
        temp.url = "/apiv2/activity/detail";
        temp.data = {
          activityId: this.activityId,
          productId: this.goodId,
          isShop: this.isShop,
          sharePromotion: getUrlParams("promotion") || "",
        };
      } else if (this.isSpecialty) {
        temp.url = "/apiv2/room/getGoodsPartInfo";
        temp.data = {
          productId: this.goodId,
          activityId: this.activityId,
          rateplan: this.rateplan,
          isShop: this.isShop,
          sharePromotion: getUrlParams("promotion") || "",
        };
      } else {
        // 新门票和票券
        temp.url = "/apiv2/room/couponDetail";
        temp.data = {
          productId: this.goodId,
          activityId: this.activityId,
          rateplan: this.rateplan,
          isShop: this.isShop,
          sharePromotion: getUrlParams("promotion") || "",
        };
      }
      if (
        !this.isSpecialty &&
        window.cityLatLongByCode &&
        localStorage.getItem("shopping_mall_city")
      ) {
        var selectCityCode = JSON.parse(
          localStorage.getItem("shopping_mall_city")
        ).cityCode; //用户首页所选择的城市代码
        if (selectCityCode && cityLatLongByCode[selectCityCode]) {
          temp.data.selectLongitude =
            cityLatLongByCode[selectCityCode].longitude;
          temp.data.selectLatitude = cityLatLongByCode[selectCityCode].latitude;
        }
      }
      try {
        let res = await new Promise((resolve, reject) => {
          Databus({
            type: "get",
            url: temp.url,
            data: temp.data,
            success: resolve,
            error: reject,
            beforeSend: function () {
              that.showLoading("页面正在加载，请稍等");
            },
            complete: function () {
              if (document.querySelector("#prescreen")) {
                document.querySelector("#prescreen").style.display = "none";
              }
              hideLoading();

              if (isReGetProductDetail) {
                that.getProductDetail();
                return;
              }
              if (that.orderNo) return;


              that.$nextTick(function () {
                that.couponDetail.topicList &&
                  that.couponDetail.topicList.length &&
                  YCF_Plugin.reportUserAnchors({
                    event_id: "520007",
                    properties: {
                      item_id: that.goodId,
                    },
                  });
                that.isPullNew &&
                  YCF_Plugin.reportUserAnchors({
                    event_id: "400002", //商品拉新页面曝光，商品拉新页面展现商品图
                    properties: {
                      item_id: that.goodId,
                    },
                  });
                if (
                  !that.isShowTicket &&
                  !that.isRoom &&
                  !that.isSpecialty &&
                  that.couponDetail.isStore &&
                  that.couponDetail.storeData
                ) {
                  componentCenter.relatedRecommend.getRecommendList(
                    that.couponDetail.storeData.storeId
                  );
                } else {
                  componentCenter.relatedRecommend.getRecommendList();
                }
                if (that.isSpecialty || that.isShop) return;
                ex_getYCFLocInfo().then((info) => {
                  window.UnifyUpdatePromoterLocation(
                    Object.assign({}, info, {
                      promoterId: that.promoter.promoterId,
                    })
                  );
                });
                // 红包弹窗
                that.$refs.popupRedpacket.initComponent();
              });
            },
          });
        });

        if (res.code == 1000 && res.bcode == 100) {
          that.$nextTick(() => {
            $("img.lazy").lazyload({
              effect: "fadeIn",
              container: $(".page"),
            });
          })
          // 初始化红包弹窗
          res.content = res.content || {};
          that.fetchMagscenicDetail(res.content);
          // 商详common参数处理
          // that.couponDetail = res.content.hotelAllName;
          // that.couponDetail.licenseUrl = res.content.licenseUrl;
          //产品类型判断和相应数据处理
          if (!that.isRoom && !that.isSpecialty) {
            if (res.content.cateId == 1 || res.content.cateId == 2) {
              //旧版详情页已经废弃！
              that.isOnline = false; //强制下线处理
            } else if (
              res.content.cateId == 3 ||
              res.content.cateId == 4 ||
              res.content.cateId == 5
            ) {
              that.isTicket = true; //票券产品
            } else if (res.content.cateId == 6) {
              //新客房没有详情页！
              that.isOnline = false; //强制下线处理
            } else if (res.content.cateId == 7) {
              //链接路径有误
              that.isSpecialty = true; //特产产品，更新链接
              history.replaceState(
                "",
                "",
                location.href.replace(
                  /ticketProductDetails|entranceTicketDetails|showTicketDetails|productDetail/,
                  "specialDetails"
                )
              );
              if (!that.orderNo) {
                isReGetProductDetail = true;
                return false;
              }
            } else if (res.content.cateId == 8) {
              that.isEntranceTicket = true; //新门票产品
              if (res.content.isMultipleDetails) {
                //新门票多产品集合模式
                that.isMultipleDetails = true;
                res.content.restrictionDetails = ""; //主产品不显示限购规则
                res.content.maxNum = -1; //主产品没有微信号限购
              }
            } else if (res.content.cateId == 9) {
              //链接路径有误或缺少isRoom参数！
              that.isRoom = true; //微客房产品，更新链接
              history.replaceState(
                "",
                "",
                updateUrlParam(
                  location.href.replace(
                    /ticketProductDetails|showTicketDetails|productDetail/,
                    "entranceTicketDetails"
                  ),
                  "isRoom",
                  "1"
                )
              );
              if (!that.orderNo) {
                isReGetProductDetail = true;
                return false;
              }
            } else if (res.content.cateId == 10) {
              that.isShowTicket = true; //演出票产品
              res.content.retailPrice = 0; //演出票产品屏蔽原价
              that.isAPP &&
                !ykzApp.showAddressMap &&
                $(".time-address .show-address").addClass("no-arrow"); //低于v1.5.0版本的app,隐藏演出地址箭头
            } else {
              //未定义的产品类型！
              that.isOnline = false; //强制下线处理
            }
          }
          if (that.isRoom) {
            //微客房，该产品的详情接口未返回cateId
            res.content.retailPrice < 0.1 && (res.content.retailPrice = 0); //不展示官方推过来0.03元的门市价
            that.roomDetails = res.content.roomDetails || {}; //房型详情数据
            !res.content.activityId &&
              (res.content.goodsAlias = res.content.goodsName); //常规微客房没有标题，用名称替代
          }
          if (that.isSpecialty) {
            //特产
            if (res.content.cateId != 7) {
              that.isSpecialty = false;
              if (
                res.content.cateId == 3 ||
                res.content.cateId == 4 ||
                res.content.cateId == 5
              ) {
                that.isTicket = true; //票券产品，更新链接
                history.replaceState(
                  "",
                  "",
                  location.href.replace(
                    "specialDetails",
                    "ticketProductDetails"
                  )
                );
              } else if (res.content.cateId == 8) {
                that.isEntranceTicket = true; //新门票产品，更新链接
                history.replaceState(
                  "",
                  "",
                  location.href.replace(
                    "specialDetails",
                    "entranceTicketDetails"
                  )
                );
              } else if (res.content.cateId == 9) {
                that.isRoom = true; //微客房产品，更新链接
                history.replaceState(
                  "",
                  "",
                  updateUrlParam(
                    location.href.replace(
                      "specialDetails",
                      "entranceTicketDetails"
                    ),
                    "isRoom",
                    "1"
                  )
                );
              } else if (res.content.cateId == 10) {
                that.isShowTicket = true; //演出票产品，更新链接
                history.replaceState(
                  "",
                  "",
                  location.href.replace("specialDetails", "showTicketDetails")
                );
              } else {
                that.isOnline = false; //强制下线处理
              }
              if (!that.orderNo) {
                isReGetProductDetail = true;
                return false;
              }
            }
          }

          //购买须知富文本字段名统一，新门票和微客房返回了ticketNotes，特产返回了purchaseNotice，要统一成instruction
          if (
            !that.orderNo &&
            (that.isEntranceTicket || that.isRoom || that.isSpecialty)
          ) {
            res.content.instruction = that.isSpecialty
              ? res.content.purchaseNotice
              : res.content.ticketNotes;
          }

          //交易快照模式，新上单票券、新门票、特产的轮播图都当做属于新图片
          if (
            that.orderNo &&
            ((that.isTicket && res.content.voucherTicketNewEditMark) ||
              that.isEntranceTicket ||
              that.isSpecialty)
          ) {
            if (res.content.album instanceof Array) {
              for (var i in res.content.album) {
                if (typeof res.content.album[i] == "object") {
                  res.content.album[i].isNew = 1;
                }
              }
            }
          }

          //富文本处理
          if (isEmptyHtml(res.content.instruction)) {
            //购买须知
            res.content.instruction = "";
          } else {
            let instruction = await lolila_2_nanuli_core(
              res.content.instruction
            );
            res.content.instruction = lazyWithStr(instruction);
          }
          if (isEmptyHtml(res.content.imageTxt)) {
            //特色介绍
            res.content.imageTxt = "";
          } else {
            res.content.imageTxt = lazyWithStr(res.content.imageTxt);
          }
          if (isEmptyHtml(res.content.productParameter)) {
            //商品参数
            res.content.productParameter = "";
          } else {

            res.content.productParameter = lazyWithStr(res.content.productParameter);
          }
          if (
            !that.isRoom ||
            res.content.activityId ||
            isEmptyHtml(res.content.scenicNotes)
          ) {
            //酒景购买须知
            res.content.scenicNotes = "";
          } else {
            let scenicNotes = await lolila_2_nanuli_core(
              res.content.scenicNotes
            );
            res.content.scenicNotes = lazyWithStr(scenicNotes);
          }

          // 初始化轮播图相册
          that.fetchOfficialAlbum(res.content);



          //第三方浏览器打开、店铺模式都隐藏话题入口
          if (that.isOtherBrowser || that.isShop) {
            res.content.topicList = [];
          }

          //份、微信号限购字段处理
          !res.content.baseValueUnit && (res.content.baseValueUnit = "份");
          if (
            res.content.restrictionDetails &&
            res.content.restrictionDetails.weChat
          ) {
            res.content.weChatDay = res.content.restrictionDetails.weChat.day;
            res.content.maxNum = res.content.restrictionDetails.weChat.limit;
          } else {
            res.content.maxNum = -1;
          }
          that.canBuy = res.content.maxNum; //详情页的canBuy字段暂时屏蔽
          that.couponDetail = res.content;

          that.initExpand(); // 初始化折叠内容
          console.log("--------ok--------", that.couponDetail);
          that.activityId = that.couponDetail.activityId || ""; //更新活动id
          try {
            rateplanProcessing(that); //价格计划
          } catch (e) {
            console.log(e);
          }
          that.validityTxt = getValidityTxt(
            res.timeStamp,
            res.content.validityStartTime,
            res.content.validityEndTime
          ); //有效期

          //标题、倒计时、购买按钮文案
          if (that.orderNo) {
            document.title = "交易快照";
            that.buyBtnTxt = that.activityId ? "立即抢购" : "立即预订";
          } else {
            if (that.couponDetail.isPresell == 1) {
              that.weChatType == 2 &&
                (document.title =
                  that.isAPP || that.isFxb
                    ? "限时抢购"
                    : "云客赞优选 - 限时抢购");
              that.couponDetail.serverTimeStamp = res.timeStamp;
              that.initCountDown();
            } else {
              that.weChatType == 2 &&
                (document.title =
                  that.isAPP || that.isFxb
                    ? "精选推荐"
                    : "云客赞优选 - 精选推荐");
              that.buyBtnTxt = "立即预订";
            }
            if (that.isShop) document.title = "限时抢购";
            if (that.isShopKeeper) that.buyBtnTxt = "推广";
          }

          //app专享价
          if (
            !that.orderNo &&
            (that.isTicket || that.isSpecialty) &&
            that.activityId &&
            that.couponDetail.isPresell == 1 &&
            that.queueStatus != 2
          ) {
            that.couponDetail.addPrice = +that.couponDetail.addPrice || 0;
            if (that.couponDetail.addPrice) {
              that.$set(
                that.couponDetail,
                "originalActivityPrice",
                that.couponDetail.activityPrice
              ); //保存原来的活动价
              if (!that.isAPP) {
                that.couponDetail.activityPrice = +(
                  +that.couponDetail.activityPrice + that.couponDetail.addPrice
                ).toFixed(2);
              } else {
                that.couponDetail.addPrice = 0;
              }
            }
          } else {
            that.couponDetail.addPrice = 0;
          }
          that.priceTxtArr = String(
            that.activityId
              ? that.couponDetail.activityPrice
              : that.couponDetail.sellPrice
          ).split(".");
          !that.priceTxtArr[1] && (that.priceTxtArr[1] = 0);
          //门店数据兼容处理
          if (
            !that.isShowTicket &&
            !that.isRoom &&
            !that.isSpecialty &&
            that.couponDetail.isStore &&
            that.couponDetail.storeData
          ) {
            that.couponDetail.scenicCover = that.couponDetail.storeData.facePic;
            that.couponDetail.hotelName = that.couponDetail.storeData.storeName;
            that.couponDetail.averageRate = +that.couponDetail.storeData.score;
            that.couponDetail.address = that.couponDetail.storeData.address;
            that.couponDetail.latitude = that.couponDetail.storeData.latitude;
            that.couponDetail.longitude = that.couponDetail.storeData.longitude;
            that.couponDetail.phone = that.couponDetail.storeData.telephone;
            that.couponDetail.sellerAvgPrice =
              that.couponDetail.storeData.sellerAvgPrice;
          }

          //新预售兼容，可显示查看预约库存入口，用additionalType字段兼容
          if (that.couponDetail.isNewGlobalSale == 1) {
            that.couponDetail.additionalType = 2;
          }
          standardProcessing(that); //规格数据处理
          that.getPromoter(); //奖励数据处理
          if (that.orderNo || !that.isTicket) {
            YCF_Plugin.reportUserAnchors({
              event_id: "500004",
              platForm:
                sessionStorage.getItem("isOtherBrowsers_platForm") || "",
              event_content: {
                item_id: that.goodId,
                topic_id: that.fromTopicId,
              },
              properties: {
                channel_id: sessionStorage.getItem("channel_ref") || undefined,
              },
            });
          }
          if (that.orderNo) return;
          //以下逻辑交易快照模式都不调用

          componentCenter.customerService.getCustomerService(
            that.couponDetail.hotelId
          );
          that.isSpecialty && that.getSoldMsg();
          that.isTicket && that.getABTest();

          if (
            that.isTicket &&
            !that.couponDetail.isSetReservationStock &&
            that.couponDetail.isSupportOnlineReserve == 1
          ) {
            that.couponDetail.stockShow = 2;
          }
          if (that.couponDetail.stockShow == 2) {
            const { isShowNotSale } = that.couponDetail;
            that.buyBtnTxt =
              isShowNotSale && isShowNotSale == 1 ? "未开售" : that.couponDetail.isPresell == 1 ? "已抢光" : "已售罄";
          }
          if (that.couponDetail.statusIs == 2 || that.queueStatus == 2) {
            that.isOnline = false;
            that.buyBtnTxt = "已抢光";
          }

          /*  商品推荐1.3需求 2019-10-17 start */
          that.promotionCity = {
            cityName: res.content.cityName,
            cityCode: res.content.cityCode,
            districtName: res.content.districtName,
            districtCode: res.content.districtCode,
          };

          var storeData = res.content.storeData || {},
            storeId = storeData.storeId || 0,
            hotelScenicId = res.content.hotelScenicId;

          const { goodId } = res.content;

          const goodDetailQuery = {
            id: hotelScenicId ? hotelScenicId : goodId,
            type: hotelScenicId ? 1 : 3,
          };
          // 根据接口返回控制下载app tips展示
          that.getGoodDetailIsShowDownload(goodDetailQuery);
          that.relationType = storeId ? 2 : 1; // 1酒景，2门店
          that.relationTypeId = storeId || hotelScenicId;
          if (!that.specialOperation && hotelScenicId == "33352") {
            that.specialOperation = true;
          }
          /*  商品推荐1.3需求 2019-10-17 end */

          /* 商详页系统返回首页 */
          if (
            that.isShop ||
            that.isOtherBrowser ||
            document.referrer ||
            isYkzMiniprogram()
          ) {
            //不兼容店铺模式、第三方打开、页面跳转过来、微信小程序
            that.couponDetail.isReturnHome = 0;
          }
          if (that.couponDetail.isReturnHome) {
            if (history.state != "return_home")
              history.pushState("return_home", "", "");
            window.onpopstate = function (event) {
              if (!location.hash && event.state != "return_home") {
                sessionStorage.setItem("from_product_to_home", 1); //用于下单标记
                sessionStorage.setItem("to_home_by_product", 1); //用于首页打锚点
                // location.replace(
                //     "/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=" +
                //         that.weChatId
                // );
                const url =
                  "/front/promoter/shoppingMallv2?weChatId=1&fromWeChatId=" +
                  that.weChatId;
                goToHome(url);
              }
            };
          }
        } else {
          if (that.orderNo) {
            that.toast(res.message || "未获取到交易快照数据！");
          } else {
            that.isOnline = false;
            that.buyBtnTxt = "已抢光";
          }
        }

        //返回有效期文案
        function getValidityTxt(current, start, end) {
          if (typeof start == "undefined" || typeof end == "undefined")
            return "";
          if (that.isShowTicket) return ""; //演出票产品，不显示有效期
          if (!that.isTicket && that.couponDetail.isCalendar) return ""; //日历模式，不显示有效期
          if ((that.isEntranceTicket || that.isRoom) && !(start && end))
            return ""; //新门票和微客房，接口未返回开始或结束时间戳（日期），不显示有效期
          if (that.isSpecialty) return ""; //特产产品，不显示有效期

          var validityTxt = "";
          if (that.isTicket) {
            if ((start + "").length >= 10) {
              validityTxt = getFormatDate(start) + " 至 " + getFormatDate(end);
            } else {
              if (start) {
                validityTxt =
                  getFormatDate(end) + "前有效，购买" + start + "小时后生效";
              } else {
                validityTxt =
                  getFormatDate(current) + " 至 " + getFormatDate(end);
              }
            }
          } else {
            //有可能返回时间戳或日期格式
            if (+start && +end) {
              validityTxt = getFormatDate(start) + " 至 " + getFormatDate(end);
            } else {
              validityTxt = start + " 至 " + end;
            }
          }
          return validityTxt;

          function getFormatDate(timeStamp) {
            var dateObj = new Date(timeStamp * 1000),
              year = dateObj.getFullYear(),
              month = dateObj.getMonth() + 1,
              day = dateObj.getDate();
            month < 10 && (month = "0" + month);
            day < 10 && (day = "0" + day);
            return year + "-" + month + "-" + day;
          }
        }
      } catch (error) {
        that.toast("网络异常");
      }
    },

    // 获取访客记录
    fetchVisitLog(detail) {
      const { goodId } = detail;
      Databus({
        type: "get",
        url: "apiv2/goods/getVisitLog",
        data: { goodsId: goodId },
        success: (res) => {
          const { code, bcode, content } = res || {};
          if (code !== 1000 || bcode !== 100 || !content || !content.length) {
            throw new Error(data.message || '获取失败，请刷新重试');
          }
          this.notifications = content;
        },
      });
    },

    fetchMagscenicDetail(detail) {
      const { storeData, hotelScenicId } = detail;
      Databus({
        type: "get",
        url: "/api/scenic/magscenicDetail",
        data: {
          scenicId: hotelScenicId
            ? hotelScenicId
            : storeData
              ? storeData.storeId
              : "",
        },
        origin: Origins.API_GOOD,
        success: (res) => {
          const { code, bcode, content } = res || {};
          if (code !== 1000 || bcode !== 100 || !content) {
            throw new Error(data.message || '获取失败，请刷新重试');
          }
          this.magscenicDetail = content;
        },
      });
    },
    // ************** banner start ***************
    onSlideChangeStart(swiper) {

      // 最后一张直接进入相册
      if (this.bannerList.length == this.bannerIndex + 1) {
        // 跳到第一个tag
        this.toAlbum(this.bannerList[0].tagId || '', 'official')
      }




      this.$nextTick(() => {


        const tagId = this.bannerList[this.bannerIndex].tagId;
        const targetElement = document.querySelector(`.nav-item-localtion${tagId}`);
        if (targetElement) {
          const container = document.querySelector('.nav-bar-left'); // 包裹横向滚动的容器
          if (container) {
            // 计算目标元素的左侧偏移量，并设置容器的 scrollLeft 值
            const offsetLeft = targetElement.offsetLeft - container.offsetLeft;
            const extraOffset = 20; // 调整偏移量，值可根据需求调整

            container.scrollTo({
              left: offsetLeft - extraOffset, // 加上额外偏移量
              behavior: 'smooth', // 平滑滚动
            });
          }
        }

        this.updateSwiper();
      });
    },
    onSlideChangeEnd(swiper) {
      // console.log('onSlideChangeEnd', swiper);
    },

    // ************** banner end ***************

    // 初始化轮播图
    initSwiper() {

      // 判断最后一张是左滑还是右滑
      const isRight = (dx, dy) => {
        let angle = (Math.atan2(dy, dx) * 180) / Math.PI;
        if (
          (angle >= 135 && angle <= 180) ||
          (angle >= -180 && angle < -135)
        ) {
          return true;
        }
        return false;
      }


      let startX = 0;
      let startY = 0;


      this.$nextTick(() => {
        this.mySwiper = new Swiper("#swiper", {
          ...this.swiperOptions,
          onInit: () => {
            console.log('swiper init');

            // this.$nextTick(() => {
            //   if ($(".page").length && $("img.lazy").length) {
            //     $("img.lazy").lazyload({
            //       effect: "fadeIn",
            //       container: $(".page"),
            //     });
            //   } else {
            //     console.warn("LazyLoad 初始化失败：目标元素不存在");
            //   }

            // })

          },
          onSlideChangeStart: (swiper) => {

            this.bannerIndex = swiper.activeIndex;
            this.onSlideChangeStart(swiper);

          },
          onTouchStart: function (swiper, event) {
            if (event.type === "touchstart") {
              startX = event.touches[0].pageX;
              startY = event.touches[0].pageY;
            }
          },
          onTouchEnd: (swiper, event) => {
            if (event.type === "touchend") {
              let endX = event.changedTouches[0].pageX;
              let endY = event.changedTouches[0].pageY
              const dx = endX - startX
              const dy = startY - endY;
              // 最后一张直接进入相册
              if (this.bannerList.length == this.bannerIndex + 1 && isRight(dx, dy)) {
                // 跳到第一个tag
                this.toAlbum(this.bannerList[0].tagId || '', 'official')
              }
            }
          },
        });



      });
    },
    // 判断是否应该跳转到相册
    shouldGoToAlbum(swiper) {
      const totalLen = this.goodsDetails.cloudId ? this.bannerList.length + 1 : this.bannerList.length;
      const index = swiper.activeIndex + 1;

      // 判断是否为最后一张且满足其他条件
      return this.goodsDetails.isHasAlbum && index === totalLen && this.swiperNumber > 5;
    },
    // banner导航栏切换
    changeNav(value, switchTab) {
      if (value) {
        const index = this.bannerList.findIndex(v => v.tagId == value);
        this.bannerIndex = index;
        this.mySwiper.slideTo(index, 100);
      } else {
        this.toAlbum(value, switchTab)
      }

    },

    toAlbum(value, switchTab) {
      const { storeData } = this.couponDetail;
      const url = "/front/platform/newPlatformAlbum?" +
        toQueryString({
          weChatId: this.weChatId,
          goodId: this.couponDetail.goodId,
          fromWeChatId: this.fromWeChatId,
          hotelScenicId: this.couponDetail.hotelScenicId,
          goodId: this.couponDetail.goodId,
          storeId: storeData ? storeData.storeId : '',
          switchTab: switchTab,
          tagId: value
        });

      location.href = url;
    },
    //  ********* 轮播视频 start *******************
    updateSwiper() {
      if (this.mySwiper) {
        this.mySwiper.update(); // 仅更新 Swiper 容器
        this.mySwiper.updateAutoHeight();

      }
    },
    // video实例
    onReady(player) {
      this.xgplayer = player;

      console.log('video就绪');
    },

    // 播放ICON
    handlePlay() {
      this.xgplayer.play()


    },
    // 暂停ICON
    handleStop() {
      this.xgplayer.pause()
    },

    // 暂停callback
    changePause() {
      this.showStartBtn = true;
      this.showStopBtn = false;

      this.updateSwiper();
    },
    // 播放callback
    changePlay() {
      this.showStartBtn = false;
      this.showStopBtn = true;
      this.showCoverImg = false;
      setTimeout(() => {
        this.updateSwiper();
      }, 50);
    },
    // 视频聚焦
    changeFocus() {
      this.showStopBtn = !this.showStopBtn;
    },
    // 视频失焦
    changeBlur() {
      this.showStopBtn = !this.showStopBtn;
    },

    // ********* 轮播视频 end *******************

    onSwiperImageLoad(event, url) {
      const imgElement = event.target; // 当前加载的图片元素
      const container = imgElement.closest(".swiper-image-wrap"); // 当前图片的父容器
      if (!container) {
        console.warn("未找到父容器");
        return;
      }

      const imageWidth = imgElement.naturalWidth;
      const imageHeight = imgElement.naturalHeight;
      const containerWidth = container.offsetWidth;

      const actualHeight = (imageHeight / imageWidth) * containerWidth;

      // 只修改当前容器的高度
      if (actualHeight < containerWidth * (1 / 2)) {
        container.style.height = `${containerWidth}px`;
      } else {
        container.style.height = `${actualHeight}px`;
      }

      // console.log(`当前容器修改为: ${container.style.height}`);
    },

    // 获取相册列表
    fetchOfficialAlbum(detail) {
      const { storeId } = detail.storeData || {}
      Databus({
        type: 'get',
        url: '/apiv2/Room/videoandpic',
        data: {
          hotelScenicId: detail.hotelScenicId || '',
          goodId: detail.goodId || '',
          storeId: storeId || ''
        },
        success: (res) => {
          const { code, bcode, content } = res;
          if (code === 1000 && bcode === 100 && content) {
            const newList = content.list.filter((v) => v.isShow == 1);

            // 构造 officialTabs 和 officialAlbum
            this.officialTabs = newList.map((item) => ({
              isShow: item.isShow,
              label: item.detailTitle,
              total: item.total || 0,
              tagId: item.tagId,
              switchTab: 'official'
            }));
            this.officialAlbum = newList;

            // 构造 bannerList：保证视频在前，图片在后
            const videoList = [];
            const imageList = [];

            newList.forEach((item) => {
              if (item.list && item.list.length) {
                item.list.forEach((v) => {
                  let banner = { tagId: item.tagId, switchTab: 'official' };
                  if (v.isVideo) {
                    banner.coverUrl = `${v.coverUrl}?imageView2/2/interlace/1/q/85`;
                    banner.url = v.url;
                    banner.type = 'video';
                    banner.group = item.detailTitle
                    videoList.push(banner);  // 视频放到视频列表中
                  } else {
                    if (v.roomImageList && v.roomImageList.length) {
                      // 床型
                      v.roomImageList.forEach(room => {
                        if (!room.isVideo) {
                          banner.group = room.imageTag
                          banner.url = room.url + '?imageView2/2/interlace/1/q/85';
                          banner.type = 'image';
                          imageList.push(banner);  // 图片放到图片列表中
                        }

                      })
                    } else {
                      banner.group = item.detailTitle
                      banner.url = v.url + '?imageView2/2/interlace/1/q/85';
                      banner.type = 'image';
                      imageList.push(banner);  // 图片放到图片列表中
                    }


                  }
                });
              }
            });



            // 将视频列表和图片列表合并，视频优先
            this.bannerList = [...videoList, ...imageList];
            this.initSwiper()
            this.fetchVisitLog(detail);

            // 设置视频自动播放 / 微信h5兼容很差暂时去掉自动播放功能
            if (detail.albumVideoAutoPlay === '1') {
              // this.autoPlay = true;
              // this.showStartBtn = false;
            } else {

            }
            this.$nextTick(() => {
              this.showStartBtn = true;
              this.showCoverImg = true;
            })
            // 更新导航栏
            this.navList = this.officialTabs;

            // console.log(this.bannerList, '轮播图');
            // console.log(this.officialAlbum, '相册officialAlbum');
          }
        },
        error: () => {
          hideLoading();
        }
      });
    },

    // 攻略列表
    getGuideList(list) {
      // 获取游客实拍
      this.fetComments().then(() => {
        this.setStrategyNav(list); // 设置攻略导航
      })
    },

    setStrategyNav(list) {
      if (!list || !list.length) return

      this.$nextTick(() => {
        this.navList.push({
          switchTab: 'strategy',
          label: '游玩攻略',
          tagId: null
        })
      })

    },


    // 获取游客实拍
    fetComments() {
      return new Promise((resolve, reject) => {
        const { goodId, hotelScenicId } = this.couponDetail;
        const { storeId } = this.couponDetail.storeData || {}
        Databus({
          type: 'get',
          url: '/apiv2/goodscomment/getList',
          data: {
            goodsId: goodId || '',
            hotelScenicId: hotelScenicId || storeId || '',
            tagId: 2, // 写死了 获取有照片的评论
            page: 1,
            pageSize: 1
          },
          success: res => {
            const { code, bcode, content } = res;
            if (code == 1000 && bcode == 100 && content) {
              if (content.list && content.list.length) {
                // 增加轮播导航
                this.navList.push({
                  switchTab: 'tourist',
                  label: '游客实拍',
                  tagId: null
                })
              }
            }
          },
          complete: () => {
            resolve();
          }

        });
      })

    },


    getGoodDetailIsShowDownload(query) {
      var that = this;
      Databus({
        type: "get",
        url: "apiv2/Room/goodDetailIsShowDrainage",
        data: query,
        success(data) {
          if (data.code == 1000 && data.bcode == 100) {
            that.isShowDownload = data.content.isShow;
          }
        },
        error(err) {
          console.log(err);
        },
      });
    },
    // 获取同类型推荐列表
    getSameRecommendList: function () {
      var that = this;

      Databus({
        url: "apiv2/marketing/getGoodByRecTagId",
        data: {
          weChatId: that.weChatId,
          page: 1,
          size: 10,
          tagId: -6,
          filterGoodId: that.goodId,
        },
        success(data) {
          if (data.code == 1000 && data.bcode == 100) {
            that.sameRecommendList = data.content.list;
          }
        },
        error(err) {
          console.log(err);
        },
      });
    },
    //分享赚钱活动
    async shareEarnActivity() {
      try {
        const res = await verifyPopularizer(); // 增加 await
        res.content = res.content || {};
        let openId = "",
          host = "";

        if (isWX() || this.isMini || this.isAPP) {
          openId = window.ykzOpenId || window.openId || "";
        } else {
          // 第三方浏览器打开
          this.setShare();
          return;
        }

        if (comm.frontEnv == "local") {
          host = "//192.168.10.165:9091";
        } else if (comm.frontEnv == "test") {
          let test = location.host.match(/test\d/g);
          host = "//corp-wechat-member.yaochufa.com";
          if (Array.isArray(test)) {
            host = `//corp-wechat-member-${test}.yaochufa.com`;
          }
        } else {
          host = "//corp-wechat-member.yaochufa.com";
        }

        ex_getYCFLocInfo().then((current) => {
          this.getSaleAndPromoter(current); // 获取销量和推广人数
          $.ajax({
            url: host + "/commission/getInviterShareKey",
            data: JSON.stringify({
              cityName: current.city || "",
              headImgUrl: res.content.userPic || "",
              nickName: res.content.nickName || "",
              openId: Base64.encode(
                openId + "#" + String(Math.random()).slice(2, 8)
              ),
              platformId: 2, // 1.周边游 2.云客赞 3.酷芽
              provinceName: current.province || "",
              shareElementId: this.goodId,
              shareType: 2,
            }),
            type: "post",
            contentType: "application/json",
            success: (result) => {
              if (result.code == 1000) {
                if (result.content.allowShare) {
                  this.ajax_shareIdKey = result.content.shareIdKey || "";
                }
              }
            },
            complete: () => {
              this.setShare();
            },
          });

          // C用户上报shareIdKey
          if (this.shareIdKey && res.content.isPopularizer != 1) {
            let seconds = 0, // 间隔多少时间上报,第一次立即上报
              that = this,
              timeId = null, // 周期函数返回的id值
              errorNum = 0, // 接口报错次数,报错达到3次,停止上报
              joinId = ""; // 接口生成的参与纪录ID
            reportInviterShareLog();
            seconds = 3; // 间隔3秒上报
            timeId = setInterval(reportInviterShareLog, seconds * 1000);

            function reportInviterShareLog() {
              $.ajax({
                url: host + "/commission/reportInviterShareLog",
                data: JSON.stringify({
                  cityName: current.city || "",
                  openId: Base64.encode(
                    openId + "#" + String(Math.random()).slice(2, 8)
                  ),
                  platformId: 2, // 1.周边游 2.云客赞 3.酷芽
                  provinceName: current.province || "",
                  seconds: seconds,
                  shareIdKey: that.shareIdKey,
                  joinId: joinId,
                }),
                type: "post",
                contentType: "application/json",
                success: (result) => {
                  if (result.code == 1000) {
                    joinId = result.content.joinId || "";
                  }
                },
                error: () => {
                  errorNum++;
                  errorNum >= 3 && clearInterval(timeId); // 接口累计报错3次,停止上报
                },
              });
            }
          }
        });
      } catch (res) {
        res.content = res.content || {};
        let openId = "",
          host = "";

        if (isWX() || this.isMini || this.isAPP) {
          openId = window.ykzOpenId || window.openId || "";
        } else {
          // 第三方浏览器打开
          this.setShare();
          return;
        }

        if (comm.frontEnv == "local") {
          host = "//192.168.10.165:9091";
        } else if (comm.frontEnv == "test") {
          let test = location.host.match(/test\d/g);
          host = "//corp-wechat-member.yaochufa.com";
          if (Array.isArray(test)) {
            host = `//corp-wechat-member-${test}.yaochufa.com`;
          }
        } else {
          host = "//corp-wechat-member.yaochufa.com";
        }

        ex_getYCFLocInfo().then((current) => {
          this.getSaleAndPromoter(current); // 获取销量和推广人数
          $.ajax({
            url: host + "/commission/getInviterShareKey",
            data: JSON.stringify({
              cityName: current.city || "",
              headImgUrl: res.content.userPic || "",
              nickName: res.content.nickName || "",
              openId: Base64.encode(
                openId + "#" + String(Math.random()).slice(2, 8)
              ),
              platformId: 2, // 1.周边游 2.云客赞 3.酷芽
              provinceName: current.province || "",
              shareElementId: this.goodId,
              shareType: 2,
            }),
            type: "post",
            contentType: "application/json",
            success: (result) => {
              if (result.code == 1000) {
                if (result.content.allowShare) {
                  this.ajax_shareIdKey = result.content.shareIdKey || "";
                }
              }
            },
            complete: () => {
              this.setShare();
            },
          });

          // C用户上报shareIdKey
          if (this.shareIdKey && res.content.isPopularizer != 1) {
            let seconds = 0, // 间隔多少时间上报,第一次立即上报
              that = this,
              timeId = null, // 周期函数返回的id值
              errorNum = 0, // 接口报错次数,报错达到3次,停止上报
              joinId = ""; // 接口生成的参与纪录ID
            reportInviterShareLog();
            seconds = 3; // 间隔3秒上报
            timeId = setInterval(reportInviterShareLog, seconds * 1000);

            function reportInviterShareLog() {
              //接口文档：http://192.168.10.165:9091/swagger-ui.html#!/35010214643682020323/reportInviterShareLogUsingPOST
              $.ajax({
                url: host + "/commission/reportInviterShareLog",
                data: JSON.stringify({
                  cityName: current.city || "",
                  openId: Base64.encode(
                    openId + "#" + String(Math.random()).slice(2, 8)
                  ),
                  platformId: 2, // 1.周边游 2.云客赞 3.酷芽
                  provinceName: current.province || "",
                  seconds: seconds,
                  shareIdKey: that.shareIdKey,
                  joinId: joinId,
                }),
                type: "post",
                contentType: "application/json",
                success: (result) => {
                  if (result.code == 1000) {
                    joinId = result.content.joinId || "";
                  }
                },
                error: () => {
                  errorNum++;
                  errorNum >= 3 && clearInterval(timeId); // 接口累计报错3次,停止上报
                },
              });
            }
          }
        });
      }
    },

    // 图片/视频预览
    previewImg(url) {

      // console.log(this.bannerList, 'this.bannerList');
      this.mediaList = this.bannerList;
      this.isPreviewVisible = true;
    },

    //设置微信分享
    setShare: async function () {
      var that = this,
        shareObj = {
          imgUrl:
            that.couponDetail.coverPic ||
            that.couponDetail.album[0].url ||
            window.comm.hotelImg ||
            window.comm.defaultHotelImg,
          descContent: (function () {
            var str = "";
            if (that.couponDetail.originalActivityPrice) {
              str =
                "APP专享价仅售" +
                that.couponDetail.originalActivityPrice +
                "元";
            } else {
              str =
                "仅售" +
                (that.activityId
                  ? that.couponDetail.activityPrice
                  : that.couponDetail.sellPrice) +
                "元";
            }
            if (that.couponDetail.retailPrice) {
              str +=
                "，" +
                (that.isSpecialty ? "原价" : "门市价") +
                that.couponDetail.retailPrice +
                "元";
              var discount =
                Math.round(
                  ((that.activityId
                    ? that.couponDetail.activityPrice
                    : that.couponDetail.sellPrice) /
                    that.couponDetail.retailPrice) *
                  100
                ) / 10;
              if (discount > 0 && discount < 7) {
                str += "，低至" + discount + "折";
              }
            }
            str += "，限时抢购";
            return str;
          })(),
          notAddShareWord: true,
          lineLink: updateUrlParam(
            location.href,
            "shareIdKey",
            this.ajax_shareIdKey
          ),
          shareTitle:
            that.couponDetail.goodsAlias ||
            that.couponDetail.goodsName ||
            window.comm.hotelName,
          anchorData: {
            item_id: that.goodId,
            type: "product",
            activity_id: that.activityId,
            source: "product",
            topic_from: getUrlParams("topicFrom") || "",
            topic_id: getUrlParams("topicId") || "",
          },
          success: function (str) {
            YCF_Plugin.reportUserAnchors({
              event_id: "500029",
              event_content: {
                item_id: that.goodId,
              },
              properties: {
                wechat_type: str == "AppMessage" ? "1" : "2", //AppMessage:分享给朋友，Timeline：分享到朋友圈
                is_test: that.ABTest.isAvailGoods, //是否开启ABtest
                group: that.ABTest.isAvailGoods
                  ? that.ABTest.userType == 1
                    ? "A"
                    : "B"
                  : undefined, //A组或B组
              },
            });
            that.promoter.isPromoter && that.promoterShareRecord();
          },
        };
      shareObj.circleShareTitle = shareObj.shareTitle + " - 云客赞优选"; //朋友圈分享标题
      if (that.isMini || that.isAPP) {
        shareObj.miniShareTitle = that.couponDetail.goodsName;
        if (that.isMini) {
          shareObj.shareInMini = true;
        } else {
          that.couponDetail.miniShareTitle = shareObj.miniShareTitle;
        }
      }
      shareObj.lineLink = updateUrlParam(shareObj.lineLink, "securityKey", "");
      shareObj.lineLink = updateUrlParam(shareObj.lineLink, "isGuide", "");
      shareObj.lineLink = updateUrlParam(shareObj.lineLink, "isPoint", "");
      shareObj.lineLink = updateUrlParam(shareObj.lineLink, "isPullNew", "");
      const isInNewbActivity = await that.popups();
      if (isInNewbActivity) {
        shareObj.lineLink = updateUrlParam(
          shareObj.lineLink,
          "userId",
          window.userId
        );
      }
      if (that.isShop) {
        YCF_Plugin.setWeiXinShare(
          shareObj,
          sessionStorage.getItem("isShop_promotion") || ""
        );
        if (that.isShopKeeper) {
          that.shareLink = updateUrlParam(
            shareObj.lineLink,
            "promotion",
            sessionStorage.getItem("isShop_promotion") || ""
          );
          that.posterLink = shareObj.lineLink;
        }
        return; //店铺模式，promotion加密串需要使用店长的
      }
      window.defShareObj = shareObj; //覆盖头像浮层组件的微信分享
      getUserPromotion().then(function (promotion) {
        that.getMiniShareImgUrl(shareObj, promotion, callback);

        function callback() {
          YCF_Plugin.setWeiXinShare(shareObj, promotion);
          //商品口令
          if (!that.isAPP) {
            YCF_Plugin.createPassword({
              procuctImg: shareObj.imgUrl, //图片链接
              productTitle: shareObj.shareTitle, //标题
              price: that.activityId
                ? that.couponDetail.addPrice
                  ? that.couponDetail.originalActivityPrice
                  : that.couponDetail.activityPrice
                : that.couponDetail.sellPrice, //价格
              commission: that.promoter.appSellComm || "", //奖励
              productUrl: updateUrlParam(
                updateUrlParam(shareObj.lineLink, "promotion", ""),
                "channel",
                "appCommand"
              ),
              //口令清除promotion参数，替换channel参数
            })
              .success(function (password) {
                that.password = password;
                that.passwordGenerated = true;
              })
              .fail(function () {
                that.toast("口令生成失败");
                that.passwordGenerated = true;
              });
          }

          //海报链接和分享链接
          if (that.promoter.isShare) {
            that.posterLink = updateUrlParam(
              shareObj.lineLink,
              "promotion",
              promotion
            ); //生成海报所需要的二维码链接
            that.shareLink = updateUrlParam(
              that.posterLink,
              "channel",
              "shortUrl"
            ); //用于生成短链接的分享链接
            that.posterLink = updateUrlParam(
              that.posterLink,
              "channel",
              that.isAPP ? "appPoster" : "poster"
            );
            sessionStorage.getItem("showProductMask") &&
              that.showProductPromotion("showProductMask");
          } else {
            that.shareLink = updateUrlParam(
              shareObj.lineLink,
              "channel",
              "shortUrl"
            ); //用于生成短链接的分享链接
          }
        }
      });
    },
    // 是否是新b三单推广
    popups: function () {
      let time = new Date().getTime();
      return new Promise(function (resolve, reject) {
        Databus({
          type: "get",
          url: "/api/freshShareOut/popups",
          origin: Origins.API_MARKETING,
          data: {
            pageType: 2,
          },
          success: (res) => {
            if (res.code == 1000 && res.bcode == 100) {
              if (
                res.content.validUntil &&
                res.content.validUntil * 1000 > time &&
                res.content.activityInfo.hasTaken
              ) {
                resolve(true);
                return;
              }
            }
            resolve(false);
          },
          error: () => {
            resolve(false);
          },
        });
      });
    },
    //获取推广员是否可推广该产品，获取相应奖励
    getPromoter: function (update) {
      var that = this;
      if (
        this.orderNo ||
        (this.isAPP && this.isTourist) ||
        this.isOtherBrowser ||
        this.isShop
      ) {
        completeFunc();
        return;
      }
      if (update && that.promoterAjaxData) {
        successFunc(JSON.parse(JSON.stringify(that.promoterAjaxData))); //更新奖励数据
        return;
      }
      Databus({
        url: "/apiv2/marketing/getShareStautsOfPromoter",
        type: "get",
        data: {
          fxbInviteCode: getUrlParams("fxbInviteCode") || "",
          productId: this.goodId,
          rateplan: this.rateplan,
          promotion: (this.isPullNew && getUrlParams("promotion")) || "", //用于商品拉新模式
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            if (
              res.content &&
              !res.content.isPromoter &&
              componentCenter.topicOffer
            ) {
              componentCenter.topicOffer.showUserCoupon();
            } else {
              that.isShowUserCoupon = 0;
            }
            that.promoterAjaxData = JSON.parse(JSON.stringify(res)); //保存ajax数据，防止共用地址指针
            successFunc(res);
          }
        },
        error: function () {
          that.toast("网络有误，请重试");
        },
        complete: function () {
          completeFunc();
        },
      });

      function successFunc(res) {
        res.content = res.content || {};
        if (res.content.isShare) {
          res.content.tempSellComm = "";
          res.content.tempAppSellComm = "";
          res.content.isMultipleCommission = false; //微信端 推广奖励是否是多奖励，默认false
          res.content.isAppMultipleCommission = false; //app端 推广奖励是否是多奖励，默认false
          if (that.isMultipleDetails) {
            //新门票多产品集合接口返回的奖励列表是新字段，需要兼容一下
            res.content.skuCommList = res.content.otherSkuCommList;
          }
          if (that.rateplan && that.isRateplan) {
            //价格计划屏蔽会员奖励加成
            res.content.isOpenMemberCommission = 0;
          }

          //限时奖励上浮数据处理
          let isCommFloating = false; //是否处于奖励上浮中,默认false
          if (res.content.isHaveHighCommission) {
            var currentTime = Math.ceil(new Date().getTime() / 1000);
            res.content.currentTime = currentTime; //保存当前时间戳
            if (
              (res.content.activityType == 0 &&
                currentTime >= res.content.startTimeCountDown &&
                currentTime < res.content.endTimeCountDown) ||
              (res.content.activityType == 1 &&
                currentTime >= res.content.startTimeCountDown &&
                res.content.num > 0)
            ) {
              isCommFloating = true;
              res.content.floatUp = true; //奖励栏需要显示限时或限份活动信息
              res.content.notFloatSellComm = res.content.sellComm; //保存未上浮的微信奖励
              res.content.notFloatAppSellComm = res.content.appSellComm; //保存未上浮的app奖励
              res.content.sellComm = res.content.wechatAward;
              res.content.appSellComm = res.content.appAward;
              for (var i in res.content.skuCommList) {
                for (var j in res.content.skuCommissionList) {
                  if (
                    res.content.skuCommList[i].skuId ==
                    res.content.skuCommissionList[j].skuId
                  ) {
                    res.content.skuCommList[i].sellComm =
                      res.content.skuCommissionList[j].wechatAward;
                    res.content.skuCommList[i].appSellComm =
                      res.content.skuCommissionList[j].appAward;
                    res.content.skuCommList[i].excellentAward =
                      res.content.skuCommissionList[j].excellentAward;
                    break;
                  }
                }
              }
            } else if (currentTime < res.content.startTimeCountDown) {
              res.content.floatUp = true; //奖励栏需要显示限时或限份活动信息
            }
          }

          //计算会员奖励加成具体金额
          if (res.content.isOpenMemberCommission && +res.content.memberReward) {
            var highSellCommNum =
              (typeof res.content.sellComm == "string" &&
                +res.content.sellComm.replace(/[^0-9|.]/g, "")) ||
              0, //最高微信奖励提取的浮点数
              highAppSellCommNum =
                (typeof res.content.appSellComm == "string" &&
                  +res.content.appSellComm.replace(/[^0-9|.]/g, "")) ||
                0; //最高app奖励提取的浮点数
            if (res.content.sellComm.search("%") != -1) {
              //微信奖励和app奖励，是统一的类型，要么都是￥，要么都是%
              res.content.memberRewardMoney =
                Math.round(
                  (that.activityId
                    ? that.couponDetail.activityPrice
                    : that.couponDetail.sellPrice) *
                  ((that.isAPP ? highAppSellCommNum : highSellCommNum) /
                    100) *
                  (+res.content.memberReward / 100) *
                  100
                ) / 100;
            } else {
              res.content.memberRewardMoney =
                Math.round(
                  (that.isAPP ? highAppSellCommNum : highSellCommNum) *
                  (+res.content.memberReward / 100) *
                  100
                ) / 100;
            }
            res.content.memberRewardMoney = res.content.memberRewardMoney
              ? "￥" + res.content.memberRewardMoney.toFixed(2)
              : 0;
          }

          commAddgoodComm(res.content);

          //推广奖励增加推广奖励
          function commAddgoodComm(comm) {
            if (typeof comm != "object") return false;

            //非优秀云客，收入说明弹框需要展示 "￥10（砖石图标 云客￥11）  "的样式
            comm.originalSellComm = comm.sellComm; //加上推广奖励前的微信奖励
            comm.originalAppSellComm = comm.appSellComm; //加上推广奖励前的app奖励

            let nameList = []; //要加上推广奖励的属性名称列表
            if (
              comm.excellentAward &&
              typeof comm.excellentAward == "string" &&
              that.getIsShow(comm.excellentAward)
            ) {
              var excellentAwardNum =
                +comm.excellentAward.replace(/[^0-9|.]/g, "") || 0; //推广奖励提取的浮点数
              if (isCommFloating) {
                nameList = ["sellComm", "appSellComm"];
              } else {
                nameList = ["wechatAward", "appAward"];
              }
              for (var i in nameList) {
                addgoodComm(nameList[i], excellentAwardNum);
              }
            }
            if (
              comm.goodComm &&
              typeof comm.goodComm == "string" &&
              that.getIsShow(comm.goodComm)
            ) {
              var goodCommNum = +comm.goodComm.replace(/[^0-9|.]/g, "") || 0; //推广奖励提取的浮点数
              if (isCommFloating) {
                nameList = ["notFloatSellComm", "notFloatAppSellComm"];
              } else {
                nameList = ["sellComm", "appSellComm"];
              }
              for (var i in nameList) {
                addgoodComm(nameList[i], goodCommNum);
              }
            }

            function addgoodComm(name, commNum) {
              if (comm[name] && typeof comm[name] == "string") {
                var nameNum = +comm[name].replace(/[^0-9|.]/g, "") || 0; //提取奖励的浮点数
                comm[name] = (nameNum + commNum).toFixed(2);
                if (comm.goodComm.search("%") != -1) {
                  //微信奖励、app奖励、推广奖励，是统一的类型，要么都是￥，要么都是%
                  comm[name] += "%";
                } else {
                  comm[name] = "￥" + comm[name];
                }
              }
            }
          }

          for (var i in res.content.skuCommList) {
            commAddgoodComm(res.content.skuCommList[i]);
            if (res.content.sellComm != res.content.skuCommList[i].sellComm) {
              res.content.isMultipleCommission = true;
            }
            if (
              res.content.appSellComm != res.content.skuCommList[i].appSellComm
            ) {
              res.content.isAppMultipleCommission = true;
            }
          }

          if (
            that.isPullNew &&
            sessionStorage.getItem("byPullNewPageReload") &&
            res.content.promotionButton == 0
          ) {
            res.content.promotionButton = 0;
          } else {
            res.content.promotionButton = 1;
          }
        }
        that.promoter = res.content;
        that.promoter.isHaveHighCommission &&
          that.$nextTick(() => {
            componentCenter.floatUp &&
              componentCenter.floatUp.initCountDown(that.promoter);
          });
        !that.isAPP && !that.promoter.isPromoter && that.getRegisterEntrance();
      }

      function completeFunc() {
        window.componentCenter.selectStandard.getSpecification({
          type: 1,
          activityId: that.activityId,
          standardList: that.standardList,
          priceAndStockNum: that.priceAndStockNum,
          promoter: that.promoter,
          isShowTicket: that.isShowTicket,
          useDate: that.couponDetail.useDate || [],
          calendarList: that.couponDetail.calendarList || [],
          seatingMap: that.couponDetail.seatingMap || "",
          isMultipleDetails: that.isMultipleDetails,
          specDetail: {
            retailPrice: that.couponDetail.retailPrice,
            canBuy: that.canBuy,
            maxNum: that.couponDetail.maxNum,
            specMaxNum: that.couponDetail.stockNum, //总库存
            restrictionDetails: that.couponDetail.restrictionDetails,
            limitDetails: that.couponDetail.limitDetails,
            isSkuLimit: that.couponDetail.isSkuLimit,
            minPrice: that.activityId
              ? that.couponDetail.activityPrice
              : that.couponDetail.sellPrice,
            coverPic: that.couponDetail.coverPic,
            baseValueUnit: that.couponDetail.baseValueUnit,
            minNum: that.isMultipleDetails ? 1 : that.couponDetail.minNum,
            maximum: that.isMultipleDetails ? -1 : that.couponDetail.maximum,
          },
        });
        that.$nextTick(function () {
          !that.orderNo && that.shareEarnActivity();
          $("img.lazy").lazyload({
            //jquery.lazyload懒加载
            effect: "fadeIn",
            container: $(".scroll-area"),
          });
          $(".graphic-detail.J_Report")[0] &&
            YCF_Plugin.addEleTOPAnchors(".graphic-detail.J_Report", {
              event_id: 610005, //曝光锚点，上报特色介绍出现在可视区域的停留时长
            });
          that.getPromoterGroup();

          //引导指示遮层
          if (
            that.promoter.isShare &&
            that.queueStatus != 2 &&
            that.isOnline &&
            !that.isAPP
          ) {
            if (
              getUrlParams("isGuide") &&
              !localStorage.getItem(
                "productDetail_isGuide_goodId=" + that.goodId
              )
            ) {
              that.isGuide = 1;
              var height_diff =
                $(".commission-bar")[0].offsetTop -
                (window.innerHeight -
                  $(".foot")[0].offsetHeight -
                  $(".commission-bar")[0].offsetHeight) /
                2;

              if (height_diff > 0) {
                $(".scroll-area").scrollTop(height_diff);
              }
              that.$nextTick(function () {
                $(".guide-cover:first").click(function () {
                  that.isGuide = 2;
                  that.$nextTick(function () {
                    $(".foot .guide-cover *").css(
                      "left",
                      $(".foot .btn-round")[0].offsetLeft + "px"
                    );
                    history.replaceState(
                      that.couponDetail.isReturnHome ? "return_home" : "",
                      "",
                      updateUrlParam(location.href, "isGuide", "").replace(
                        /&$/,
                        ""
                      )
                    );
                    localStorage.setItem(
                      "productDetail_isGuide_goodId=" + that.goodId,
                      that.goodId
                    );
                  });
                });
              });
            } else if (getUrlParams("isPoint")) {
              that.isPoint = true;
              history.replaceState(
                that.couponDetail.isReturnHome ? "return_home" : "",
                "",
                updateUrlParam(location.href, "isPoint", "").replace(/&$/, "")
              );
            } else if (
              window.isOpenNewGuide &&
              !localStorage.getItem("productDetail_isPoint")
            ) {
              that.isPoint = true;
              localStorage.setItem("productDetail_isPoint", true);
            }
          }

          var topBarHeight = $(".scroll-area .top-bar").height(), //顶部固定栏的高度
            topBarOffsetY = 0, //顶部固定栏未固定以前，到顶部的距离
            detailSelectorTxt = that.isSpecialty
              ? ".detail-txt"
              : ".detail-txt.graphic-detail"; //详情选择器的文本
          $(".scroll-area").scroll(function () {
            var scrollTop = this.scrollTop;

            //顶部固定栏显示和隐藏
            topBarOffsetY =
              $(".swiper-container")[0].offsetTop +
              $(".swiper-container").height();

            if (scrollTop >= topBarOffsetY - 2 * topBarHeight) {
              that.offsetY = scrollTop - topBarOffsetY + topBarHeight;
              that.offsetY > 0 && (that.offsetY = 0);

              if (
                that.isRecommendExists &&
                $(".cmp-promotion") &&
                $(".cmp-promotion")[0] &&
                $(".cmp-promotion")[0].offsetTop &&
                scrollTop >= $(".cmp-promotion")[0].offsetTop - topBarHeight
              ) {
                that.selectedTab = 6;
                if (!that.scrollToRecommendNavigation) {
                  that.scrollToRecommendNavigation = true; //滚动到过推荐模块
                  that.generalAnchors("scrollToRecommendNavigation");
                }
              } else if ($("#component-user-evaluation") &&
                $("#component-user-evaluation")[0] &&
                $("#component-user-evaluation")[0].offsetTop &&
                scrollTop >= $("#component-user-evaluation")[0].offsetTop - topBarHeight) {
                that.selectedTab = 5;
                if (!that.scrollToDetailNavigation) {
                  that.scrollToDetailNavigation = true; //滚动到过评论模块
                  that.generalAnchors("scrollToCommentNavigation");
                }
              }
              else if (
                $(detailSelectorTxt)[0] &&
                scrollTop >= $(detailSelectorTxt)[0].offsetTop - topBarHeight
              ) {
                that.selectedTab = 4;
                if (!that.scrollToDetailNavigation) {
                  that.scrollToDetailNavigation = true; //滚动到过详情模块
                  that.generalAnchors("scrollToDetailNavigation");
                }
              } else if (
                !that.isSpecialty &&
                $(".detail-txt.purchase-notes")[0] &&
                scrollTop >=
                $(".detail-txt.purchase-notes")[0].offsetTop - topBarHeight
              ) {
                that.selectedTab = 3;
                if (!that.scrollToNoticeNavigation) {
                  that.scrollToNoticeNavigation = true; //滚动到过须知模块
                  that.generalAnchors("scrollToNoticeNavigation");
                }
              } else if (scrollTop >= topBarOffsetY - topBarHeight) {
                that.selectedTab = 1;
                componentCenter.openApp &&
                  (componentCenter.openApp.showOpenAppBtn = true);
                componentCenter.appDownload &&
                  componentCenter.appDownload.nowAppDownLoadStatus &&
                  (componentCenter.appDownload.showAppDownload = false);
                if (!that.scrollToProductNavigation) {
                  that.scrollToProductNavigation = true; //滚动到过商品模块
                  that.generalAnchors("scrollToProductNavigation");
                }
              } else {
                that.selectedTab = -1;
                componentCenter.appDownload &&
                  componentCenter.appDownload.nowAppDownLoadStatus &&
                  (componentCenter.appDownload.showAppDownload = true);
              }
            } else {
              that.selectedTab = 0;
              componentCenter.openApp &&
                (componentCenter.openApp.showOpenAppBtn = false);
            }



            //页面滚动时，加载商品推荐数据
            if (
              !that.orderNo &&
              !that.isRateplan &&
              !that.isShop &&
              !that.isPromotionInit
            ) {
              that.isPromotionInit = true; //商品推荐数据已渲染，只加载一次
              that.$refs.promotion.init(); //商品推荐初始化
            }

            //滑到低部了
            if (
              !that.isInTheEnd &&
              scrollTop + this.offsetHeight == this.scrollHeight
            ) {
              that.isInTheEnd = true;
              that.reportUserAnchors("500110");
            }

            //显示返回顶部按钮与否
            if (!that.isShowRedpackFloat) {
              if (scrollTop >= window.innerHeight) {
                if (!that.isShowGoTop) {
                  that.isShowGoTop = true;
                  setTimeout(function () {
                    that.goTopClass = "show";
                  }, 0);
                }
              } else {
                if (that.isShowGoTop) {
                  that.goTopClass = "";
                  setTimeout(function () {
                    that.isShowGoTop = false;
                  }, 400);
                }
              }
            }
          });
        });
      }
    },
    getCommentInfos(commet) {
      this.commentInfos = commet;
    },


    //获取分享群相关信息
    getPromoterGroup: function () {
      var that = this;
      //交易快照、新门票集合模式打开不展示分享群二维码模块
      if (this.orderNo || this.isMultipleDetails) {
        setTimeout(function () {
          completeFunc();
        }, 500);
        return;
      }
      Databus({
        url: "/apiv2/marketing/getPromoterGroupQrcode",
        type: "get",
        data: {
          productId: this.goodId,
          activityId: this.activityId,
          promotion: YCF_Plugin.getPromotion() || "",
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.promoterGroup = res.content || {};
            if (that.isShop && that.promoterGroup.qrcodeType == 1) {
              that.promoterGroup = {}; //店铺模式，不展示官方公众号二维码
            } else {
              that.$nextTick(function () {
                pressEvent(".promotion-group", () => {
                  that.generalAnchors("clickBuyInfoQrCode");
                });
              });
            }
          } else {
            that.toast(res.message || "云客群二维码失败");
          }
        },
        complete: function () {
          // completeFunc();
        },
      });

      function completeFunc() {
        // that.$nextTick(function () {
        //   $("img.code-lazy").lazyload({
        //     //jquery.lazyload懒加载
        //     effect: "fadeIn",
        //     container: $(".scroll-area"),
        //   });

        //   var buyInfoHasImg = false; //购买须知富文本是否有图片，默认false
        //   if (
        //     !(that.isTicket && that.couponDetail.voucherTicketNewEditMark) &&
        //     that.couponDetail.instruction &&
        //     that.couponDetail.instruction.search(
        //       /<img (.*?)src=['"](.*?)['"](.*?)>/g
        //     ) != -1
        //   ) {
        //     buyInfoHasImg = true;
        //   }
        //   //购买须知和特色介绍的展开和收起
        //   $(".expand-collapse").each(function () {
        //     var $elem = $(".detail-txt." + $(this).attr("name"));
        //     if (!$elem[0]) {
        //       $(this).remove();
        //       return;
        //     }
        //     var collapseHeight = $elem.height(), //收起的高度
        //       expandHeight = $elem.css("height", "auto").height(); //展开以后的高度
        //     if (
        //       !that.couponDetail.isPurchaseNoticeFold ||
        //       $(this).attr("name") == "graphic-detail" ||
        //       $(this).attr("name") == "product-parameter" ||
        //       collapseHeight >= expandHeight
        //     ) {
        //       $(this).remove();
        //     } else {
        //       $elem.css("height", "");
        //       $(this)
        //         .find("span")
        //         .click(function () {
        //           if ($(this).parent().hasClass("expanded")) {
        //             $elem.css("height", "");
        //             $(this).parent().removeClass("expanded");
        //           } else {
        //             if (
        //               $(this).parent().attr("name") == "graphic-detail" ||
        //               $(this).parent().attr("name") == "product-parameter"
        //             ) {
        //               $elem.css("height", "auto"); //特色介绍和商品参数有懒加载，无法确定正确的高度，所以用高度自适应，没有过渡动画
        //               that.generalAnchors(
        //                 $(this).parent().attr("name") == "graphic-detail"
        //                   ? "expandFeatureIntroduction"
        //                   : "expandProductParam"
        //               );
        //             } else {
        //               $elem.css(
        //                 "height",
        //                 buyInfoHasImg ? "auto" : expandHeight
        //               ); //有图片时，高度不确定，没有过渡动画
        //               that.generalAnchors("expandBuyInfo");
        //             }
        //             $(this).parent().addClass("expanded");
        //           }
        //         });
        //     }
        //   });
        // });
      }
    },

    //设置或取消收藏
    setCollection: function (noToast) {
      YCF_Plugin.anchorPoint(
        "商品页收藏",
        "gooddetail_collect",
        `goodId:${this.goodId}`
      );
      if (noToast) {
        if (this.couponDetail.isSetRemind == this.couponDetail.isCollect) {
          console.log("提醒和收藏要关联！");
          return false;
        }
      } else {
        if (!this.couponDetail.isCollect) {
          if (this.couponDetail.stockShow == 2 && this.couponDetail.isShowNotSale != 1) {
            this.toast("收藏失败，商品已售罄");
            return false;
          }
          if (this.couponDetail.statusIs == 2) {
            this.toast("收藏失败，商品已下架");
            return false;
          }
          if (this.queueStatus == 2) {
            this.toast("收藏失败，活动已结束");
            return false;
          }
        }
      }

      var that = this;
      Databus({
        url: "apiv2/userCenter/promoterCollect",
        type: "get",
        data: {
          productId: this.goodId,
          activityId: this.activityId,
          productType: 1,
          actionType: this.couponDetail.isCollect ? 2 : 1,
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.couponDetail.isCollect = that.couponDetail.isCollect ? 0 : 1;
            !noToast &&
              that.$nextTick(function () {
                that.toast(
                  that.couponDetail.isCollect ? "收藏成功" : "已取消收藏"
                );
                YCF_Plugin.reportUserAnchors({
                  event_id: "500207",
                  event_content: {
                    item_id: that.goodId,
                    success: that.couponDetail.isCollect ? "true" : "false",
                  },
                });
                buryingPoint("SXY-DJSC", "点击收藏", this.kv);
              });
          } else {
            !noToast &&
              that.toast(
                res.message ||
                (that.couponDetail.isCollect ? "取消收藏失败" : "收藏失败")
              );
          }
        },
        error: function () {
          !noToast && that.toast("网络有误，请重试");
        },
        beforeSend: function () {
          !noToast && that.showLoading();
        },
        complete: function () {
          !noToast && hideLoading();
        },
      });
    },

    //判断奖励字段是否需要显示
    getIsShow: function (value) {
      if (!value || typeof value != "string") {
        return false;
      }
      var numStr = value.replace(/[^0-9]+/g, "");
      if (numStr && numStr != 0) {
        return true;
      } else {
        return false;
      }
    },

    //推广员分享产品记录
    promoterShareRecord: function () {
      Databus({
        url: "apiv2/userCenter/promoterShare",
        type: "get",
        data: {
          productId: this.goodId,
          activityId: this.activityId,
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            console.log("分享分享记录成功!");
          } else {
            console.log("分享分享记录失败!");
          }
        },
      });
    },

    //判断是否开启推广员注册入口
    getRegisterEntrance: function () {
      var that = this;
      Databus({
        url: "/apiv2/marketing/getRegisterEntrance",
        type: "get",
        data: {
          type: 1,
          goodsId: this.goodId,
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.$set(
              that.promoter,
              "registerEntrance",
              res.content.registerEntrance == 1 ? true : false
            );
          }
        },
      });
    },

    //获取产品销量、推广人数、今日必推排名
    getSaleAndPromoter(current) {
      Databus({
        url: "api/room/getSaleAndPromoter",
        type: "get",
        origin: Origins.API_GOOD,
        data: {
          goodId: this.goodId,
          city: current.city || "",
        },
        success: (res) => {
          if (res.code == 1000 && res.bcode == 100) {
            for (let keyName in res.content) {
              this.$set(this.couponDetail, keyName, res.content[keyName]);
            }
            if (!this.couponDetail.isShowSaleCount) {
              this.couponDetail.saleNum = 0;
            }
          }
        },
      });
    },

    //获取小程序分享图
    getMiniShareImgUrl: function (shareObj, promotion, callback) {
      if (!this.isAPP && !this.isMini && !this.isAlipayMini) {
        typeof callback == "function" && callback();
        return;
      }
      var that = this;
      Databus({
        url: "/apiv2/miniProgram/getSharePic",
        type: "get",
        data: {
          productId: this.goodId,
          activityId: this.activityId,
          //promotion: promotion || ""
        },
        success: function (res) {
          if (res.code == 1000 && res.bcode == 100) {
            shareObj.miniShareImgUrl = res.content.posterImg || "";
            that.couponDetail.miniShareImgUrl = shareObj.miniShareImgUrl;
          }
        },
        complete: function () {
          typeof callback == "function" && callback();
        },
      });
    },

    //设置店铺收藏
    setShopCollection() {
      let that = this,
        addressInfo = ""; //用户首页所选择的省市区信息
      if (localStorage.getItem("shopping_mall_city")) {
        addressInfo =
          JSON.parse(localStorage.getItem("shopping_mall_city")) || {};
      }
      Databus({
        url: "/api/products/shopCollection",
        type: "get",
        data: {
          productId: this.goodId,
          activityId: this.activityId,
          isCollect: 1, //是否收藏 1.是  0.否
          province: addressInfo.provinceName,
          city: addressInfo.cityName,
        },
        success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            //添加成功
            that.hasSetShopCollection = true; //是否设置过店铺收藏，true已设置
            that.toast("商品已添加到店铺精选");
          } else if (res.code == 1001) {
            //已添加
            that.hasSetShopCollection = true; //是否设置过店铺收藏，true已设置
          } else if (res.code == 1002) {
            //添加失败
            console.log(res.message);
          } else if (res.code == 1003) {
            //添加满了
            that.hasSetShopCollection = true; //是否设置过店铺收藏，true已设置
            that.toast("添加失败，店铺精选最多添加30个商品");
          }
        },
        origin: Origins.API_GOOD,
      });
    },

    //获取ABtest数据
    getABTest() {
      let that = this;
      Databus({
        url: "api/products/descAbTest",
        origin: Origins.API_GOOD,
        type: "get",
        data: {
          goodId: this.goodId,
        },
        success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.ABTest = res.content || {};
            if (
              that.ABTest.isAvailGoods &&
              that.ABTest.userType == 2 &&
              that.couponDetail.imageTxt
            ) {
              let $imageTxt = $(".detail-txt.graphic-detail>.rich-text");
              $imageTxt.contents().filter(function () {
                if (!$(this).is("div.J_TCPlayer")) {
                  $(this).remove();
                }
              });
              if (!$imageTxt.html()) {
                that.couponDetail.imageTxt = "";
              } else {
                $imageTxt
                  .find(">div.J_TCPlayer:last")
                  .attr("style", "position:relative");
              }
            }

            if (that.ABTest.isAvailGoods) {
              that.ABTest.isAvailGoods = 1;
            } else {
              that.ABTest = {};
            }
          }
        },
        complete() {
          YCF_Plugin.reportUserAnchors({
            event_id: "500004",
            platForm: sessionStorage.getItem("isOtherBrowsers_platForm") || "",
            event_content: {
              item_id: that.goodId,
              topic_id: that.fromTopicId,
            },
            properties: {
              channel_id: sessionStorage.getItem("channel_ref") || undefined,
              is_test: that.ABTest.isAvailGoods, //是否开启ABtest
              group: that.ABTest.isAvailGoods
                ? that.ABTest.userType == 1
                  ? "A"
                  : "B"
                : undefined, //A组或B组
            },
          });
        },
      });
    },

    //获取滚动的已购买用户信息
    getSoldMsg: function () {
      var that = this,
        fn = function () {
          Databus({
            url: "apiv2/room/getGoodsDynamicList",
            type: "get",
            data: {
              weChatId: that.weChatId,
              productId: that.goodId,
            },
            success: function (res) {
              if (res.code == 1000 && res.bcode == 100) {
                that.soldMsgData = res.content;

                that.$nextTick(function () {
                  that.initSoldMsg();
                });
              }
            },
          });
        };

      fn();

      clearInterval(this.soldeMsgJob1);
      // 5分钟刷新一次数据
      this.soldeMsgJob1 = setInterval(function () {
        fn();
      }, 300000);
    },

    //已购买用户信息滚动展示
    initSoldMsg: function () {
      var that = this,
        index = 0,
        len = this.soldMsgData.length,
        anit = function () {
          index = that.soldMsgIndex;

          // 如果视频正在播放或swiper移出视野外，暂停滚动
          if (!that.paused || !that.isShowSoldMsg) {
            that.soldeMsgClass = "";
            return false;
          }

          that.soldeMsgClass = "slide-in";

          setTimeout(function () {
            that.soldeMsgClass = "slide-out";
          }, 2400);

          setTimeout(function () {
            that.soldeMsgClass = "";
            index++;
            if (index === len) {
              clearInterval(that.soldeMsgJob2);
            }
            that.soldMsgIndex = index;
          }, 2800);
        };

      if (len) {
        anit();

        clearInterval(this.soldeMsgJob2);
        this.soldeMsgJob2 = setInterval(function () {
          anit();
        }, 3800);
      }
    },

    //点击抢购或预订按钮
    clickBuyBtn: function () {
      var that = this;
      if (this.orderNo) {
        if (
          componentCenter.selectStandard.showSpecification ||
          Object.getOwnPropertyNames(this.standardList).length == 1 ||
          Object.getOwnPropertyNames(this.priceAndStockNum).length == 1
        ) {
          console.log("交易快照页");
        } else {
          componentCenter.selectStandard.slideUpSpecification();
        }
        return false;
      }
      if (this.pageIsJumping) {
        this.toast("页面正在跳转，请稍等！");
        return false;
      }
      if (this.isAPP && this.isTourist) {
        console.log("游客身份,需要先登录");
        ykzApp.ready(function () {
          ykzApp.goLogin();
        });
        return false;
      }
      if (
        this.queueStatus == 2 ||
        (this.couponDetail.stockShow == 2 &&  this.couponDetail.isShowNotSale != 1) ||
        !this.isOnline
      ) {
        console.log("已抢光||已结束||已下线||已失效");
        return false;
      }
      if (this.isShopKeeper) {
        if (!this.isAPP && !this.hasSetShopCollection) {
          this.setShopCollection();
        }
        componentCenter.nobrandPromotion &&
          componentCenter.nobrandPromotion.showShare(that);
        return false;
      }
      if (this.queueStatus == 0) {
        if (
          this.isShop ||
          (this.timeObj.day == 0 &&
            this.timeObj.hour == 0 &&
            (this.timeObj.minute < 5 ||
              (this.timeObj.minute == 5 && this.timeObj.second == 0)))
        ) {
          console.log("即将开抢");
        } else {
          console.log("设置/取消提醒");
          this.reportUserAnchors("500030");
          componentCenter.setReminder.setBuyRemind({
            pageType: 1,
            activityId: this.activityId,
            goodId: this.goodId,
            type: this.couponDetail.isSetRemind ? 2 : 1,
            positionStr: "bottom",
            callback: function () {
              that.couponDetail.isSetRemind = that.couponDetail.isSetRemind
                ? 0
                : 1;
              that.buyBtnTxt = that.couponDetail.isSetRemind
                ? "取消提醒"
                : "设置提醒";
              if (that.buyBtnTxt === "取消提醒") {
                buryingPoint("SXY-DJSZTX", "点击设置提醒", that.kv);
              }
              that.setCollection("不需要toast");
            },
          });
        }
        return true;
      }
      if (
        this.canBuy != -1 &&
        componentCenter.selectStandard.buyNum > this.canBuy
      ) {
        console.log("用户购买数量已达上限");
        this.toast(
          "每个微信号" +
          (this.couponDetail.weChatDay
            ? this.couponDetail.weChatDay + "天内限购"
            : "限购") +
          this.couponDetail.maxNum +
          this.couponDetail.baseValueUnit +
          "，您已下单" +
          (this.couponDetail.maxNum - this.canBuy) +
          this.couponDetail.baseValueUnit +
          "，请关注公众号并于订单中心查看订单"
        );
        return false;
      }

      if (
        componentCenter.selectStandard.showSpecification ||
        Object.getOwnPropertyNames(this.standardList).length == 1 ||
        Object.getOwnPropertyNames(this.priceAndStockNum).length == 1
      ) {
        if (
          this.isMultipleDetails &&
          !componentCenter.selectStandard.showSpecification
        ) {
          console.log("多产品类型未封装成多规格数据");
          this.toast("套餐不存在！");
          return false;
        }
        if (componentCenter.selectStandard.finishSelected) {
          /*if(this.isShowTicket && this.couponDetail.minNum > this.canBuy && this.canBuy != -1) {
                        this.toast("商品" + this.couponDetail.minNum + this.couponDetail.baseValueUnit + "起购，您已下单" + (this.couponDetail.maxNum - this.canBuy) + this.couponDetail.baseValueUnit + "，超出购买限制，请关注公众号并于订单中心查看订单");
                        return false;
                    }*/
          console.log("立即购买");
          YCF_Plugin.reportUserAnchors({
            event_id: "500031",
            event_content: {
              pop_url: getUrlParams("promotion") || "",
              item_id: this.goodId,
              source: (this.isPullNew && "pullnewuser") || undefined,
            },
            properties: {
              item_id: this.goodId,
              is_test: this.ABTest.isAvailGoods, //是否开启ABtest
              group: this.ABTest.isAvailGoods
                ? this.ABTest.userType == 1
                  ? "A"
                  : "B"
                : undefined, //A组或B组
            },
          });
          // that.newAnchorPoint(
          //     that.promoter.isPromoter
          //         ? "B端_点击商详_购买按钮"
          //         : "C端_点击商详_购买按钮",
          //     ""
          // );
          buryingPoint("SXY-DJQGYD", "点击抢购/预定", that.kv);
          var tube = this.specIdKey
            ? this.priceAndStockNum[that.specIdKey].queueNameSec
            : this.couponDetail.queueNameSec;
          pushSets({
            //入队
            tube: tube,
            imExecute: !(
              this.activityId &&
              this.couponDetail.isQueueOpen &&
              tube
            ),
            success: function () {
              YCF_Plugin.ABTestUserInfo({
                //微信授权
                callback: function () {
                  var linkStr = "";
                  if (that.isSpecialty) {
                    //特产
                    linkStr =
                      "/front/index/specialtyConfirmOrder?" +
                      toQueryString({
                        changeCalendar: that.couponDetail.changeCalendar, //是否转为非日历模式
                        isCalendar: that.couponDetail.isCalendar, //前端日历
                        goodId: that.goodId,
                        activityId: that.activityId,
                        checkInTime: that.checkInTime,
                        checkOutTime: that.checkOutTime,
                        skuId: that.specIdKey
                          ? that.priceAndStockNum[that.specIdKey].skuId
                          : that.couponDetail.skuId, //用户所选择的规格id
                        buyNum: componentCenter.selectStandard.buyNum || 1, //用户所选择的购买数量
                        queueNameSec:
                          (that.activityId &&
                            (that.couponDetail.isQueueOpen ||
                              that.couponDetail.isUseSnapUpSystem == 1) &&
                            tube) ||
                          "", //队列名称
                        isQueueOpen:
                          (that.activityId &&
                            that.couponDetail.isQueueOpen &&
                            tube &&
                            1) ||
                          "", //排队系统
                        isUseSnapUpSystem:
                          (that.activityId &&
                            that.couponDetail.isUseSnapUpSystem == 1 &&
                            tube &&
                            1) ||
                          "", //抢购系统
                      });
                  } else if (that.isMultipleDetails) {
                    //新门票集合
                    linkStr =
                      "/front/index/entranceTicketReserve?" +
                      toQueryString({
                        changeCalendar: that.couponDetail.changeCalendar, //是否转为非日历模式
                        isCalendar: that.couponDetail.isCalendar, //前端日历
                        checkInTime: that.checkInTime,
                        checkOutTime: that.checkOutTime,
                        goodId: that.priceAndStockNum[that.specIdKey].goodId,
                        activityId:
                          that.priceAndStockNum[that.specIdKey].activityId,
                        skuId: that.priceAndStockNum[that.specIdKey].skuId,
                        buyNum: componentCenter.selectStandard.buyNum || 1,
                      });
                  } else if (that.isEntranceTicket || that.isRoom) {
                    //新门票和微客房
                    linkStr =
                      "/front/index/" +
                      (that.isRoom ? "roomReserve" : "entranceTicketReserve") +
                      "?" +
                      toQueryString({
                        changeCalendar: that.couponDetail.changeCalendar, //是否转为非日历模式
                        isCalendar: that.couponDetail.isCalendar, //前端日历
                        skuId: that.couponDetail.skuId,
                        goodId: that.goodId,
                        activityId: that.activityId,
                        checkInTime: that.checkInTime,
                        checkOutTime: that.checkOutTime,
                        queueNameSec:
                          (that.activityId &&
                            that.couponDetail.isQueueOpen &&
                            tube) ||
                          "", //队列名称
                      });
                  } else {
                    //票券和演出票
                    var ticketInfo = {
                      cateId: that.couponDetail.cateId,
                      goodsAlias: that.couponDetail.goodsAlias,
                      goodsName: that.couponDetail.goodsName,
                      goodId: that.goodId,
                      skuId: that.specIdKey
                        ? that.priceAndStockNum[that.specIdKey].skuId
                        : that.couponDetail.skuId,
                      skuName: that.specIdKey
                        ? that.priceAndStockNum[that.specIdKey].skuName
                        : that.couponDetail.skuName,
                      standardList: that.specIdKey
                        ? componentCenter.selectStandard.selectedStandardObj
                        : false,
                      validityTxt: that.validityTxt,
                      buyNum: componentCenter.selectStandard.buyNum,
                      maxNum: that.couponDetail.maxNum,
                      stockNum: that.specIdKey
                        ? that.priceAndStockNum[that.specIdKey].stockNum
                        : that.couponDetail.stockNum,
                      canBuy: that.canBuy,
                      baseValueUnit: that.couponDetail.baseValueUnit,
                      price: that.specIdKey
                        ? that.activityId
                          ? that.priceAndStockNum[that.specIdKey].activityPrice
                          : that.priceAndStockNum[that.specIdKey].price
                        : that.activityId
                          ? +that.couponDetail.activityPrice
                          : that.couponDetail.sellPrice,
                      retailPrice: that.specIdKey
                        ? that.priceAndStockNum[that.specIdKey].skuPrice
                        : that.couponDetail.retailPrice,
                      validityStartTime: that.couponDetail.validityStartTime,
                      validityEndTime: that.couponDetail.validityEndTime,
                      customerInfo: that.couponDetail.customerInfo,
                      credentials: that.couponDetail.credentials,
                      tripCertificate: that.couponDetail.tripCertificate,
                      tripName: that.couponDetail.tripName,
                      tripEName: that.couponDetail.tripEName,
                      tripPhone: that.couponDetail.tripPhone,
                      tripEmail: that.couponDetail.tripEmail,
                      needIdCard: that.couponDetail.needIdCard,
                      needEmail: that.couponDetail.needEmail,
                      //invoice: that.couponDetail.invoice,
                      //invoiceCopy: that.couponDetail.invoiceCopy,
                      invoiceTxt: that.couponDetail.invoiceTxt,
                      restrictionDetails: that.couponDetail.restrictionDetails,
                      limitDetails: that.couponDetail.limitDetails,
                      useCoupon:
                        that.useCoupon && that.couponDetail.isCouponUsable,
                      useCloudCoin: that.useCloudCoin,
                    };
                    if (that.isShowTicket) {
                      //演出票数据
                      ticketInfo.showPlace = that.couponDetail.showPlace || "";
                      ticketInfo.showGetTicketWay =
                        that.couponDetail.showGetTicketWay;
                      ticketInfo.pickupTips =
                        that.couponDetail.pickupTips || [];
                      ticketInfo.selectDate =
                        componentCenter.selectStandard.selectDate;
                      ticketInfo.minNum = that.couponDetail.minNum;
                      ticketInfo.maximum = that.couponDetail.maximum;
                      ticketInfo.tripProductNum =
                        that.couponDetail.tripProductNum;
                      ticketInfo.tripPersonNum =
                        that.couponDetail.tripPersonNum;
                    } else {
                      ticketInfo.isCityDistribution =
                        that.couponDetail.isCityDistribution || 0; //是否属于同城配送产品  1.属于  0.不属于
                      ticketInfo.baseValue = that.couponDetail.baseValue || 1; //接口未返回该字段,先这样写着,怕后续有用到基准数
                    }
                    if (that.isOtherBrowser) {
                      localStorage.setItem(
                        "ticketInfo_" + that.goodId,
                        JSON.stringify(ticketInfo)
                      );
                    } else {
                      sessionStorage.setItem(
                        "ticketInfo_" + that.goodId,
                        JSON.stringify(ticketInfo)
                      );
                    }
                    linkStr =
                      "/front/index/ticketReserve?" +
                      toQueryString({
                        changeCalendar: that.couponDetail.changeCalendar, //是否转为非日历模式
                        isCalendar: that.couponDetail.isCalendar, //前端日历
                        checkInTime: that.checkInTime,
                        checkOutTime: that.checkOutTime,
                        goodId: that.goodId,
                        activityId: that.activityId,
                        isShowTicket: that.isShowTicket || "", //属于演出票产品
                        queueNameSec:
                          (that.activityId &&
                            (that.couponDetail.isQueueOpen ||
                              that.couponDetail.isUseSnapUpSystem == 1) &&
                            tube) ||
                          "", //队列名称
                        isQueueOpen:
                          (that.activityId &&
                            that.couponDetail.isQueueOpen &&
                            tube &&
                            1) ||
                          "", //排队系统
                        isUseSnapUpSystem:
                          (that.activityId &&
                            that.couponDetail.isUseSnapUpSystem == 1 &&
                            tube &&
                            1) ||
                          "", //抢购系统
                        isH5: 1, //标记是从H5页面跳转过去的，用于预订页获取数据方法的判断
                        isABtest:
                          that.isTicket && that.ABTest.isAvailGoods
                            ? that.ABTest.userType == 1
                              ? "A"
                              : "B"
                            : "", //ABtest,所属组(A或B组)
                      });
                  }
                  linkStr +=
                    "&" +
                    toQueryString({
                      rsecond: that.queueStatus == 1 ? that.remainSeconds : 0,
                      weChatId: that.weChatId,
                      fromTopicId: that.fromTopicId, //专题页跳转到详情页所带的专题id
                      isOther: that.isOther, //非云客公众号直接通过链接访问所带的参数，用来隐藏二维码
                      rateplan: (that.isRateplan && that.rateplan) || "", //价格计划所指定的加密串
                      simData: that.simData,
                      isShop: that.isShop,
                      bookFrom: that.isOtherBrowser ? "itemDetail" : "",
                      isPullNew: that.isPullNew,
                      fromSource: that.fromSource, // 公众号跳转详情页携带的来源
                      articleId: getUrlParams("articleId"), // 公众号文章ID
                    });
                  location.href = linkStr.replace(/&$/, "");
                  that.pageIsJumping = true;
                  setTimeout(() => {
                    that.pageIsJumping = false;
                  }, 250);
                },
              });
            },
          });
        } else {
          this.toast("请选择规格");
        }
      } else {
        componentCenter.selectStandard.slideUpSpecification();
      }
    },
    getMaterialInfo() {
      Databus({
        url: "/appapi/discovery/isExistsMaterial",
        type: "get",
        data: {
          goodId: this.goodId,
        },
        success: (res) => {
          if (res.code == 1000 && res.bcode == 100) {
            this.isMaterialExists = res.content.isExists || 0;
          }
        },
      });
    },
  },
  created: function () {
    const specialOperationlist = [
      747922, 747935, 747936, 747937, 747940, 747941, 747942, 747955, 747956,
    ];
    this.specialOperation = specialOperationlist.some(
      (item) => item == this.goodId
    );
    this.viewReport();
    this.getProductDetail();
    this.getSameRecommendList();
    this.getUserCoinInfo();
    this.initCouponList();
    this.getShareOrder();
    this.isPullNew &&
      YCF_Plugin.reportUserAnchors({
        event_id: "400000", //进入商品拉新页面
        properties: {
          item_id: this.goodId,
        },
      });
    //app相关字段处理
    if (this.isAPP) {
      var that = this;
      ykzApp.ready(function () {
        that.isReviewing = ykzApp.isIOSReviewing(); //iOS审核判断，审核版本和上线版本展示样式不同
        ykzApp.getGlobalSettings({
          success: function (settings) {
            that.isWxInstalled = settings.wxInstalled; //判断用户设备是否有安装微信
          },
        });
        ykzApp.onResponse["scrollToTop"] = function () {
          that.scrollOffsetTop(".scroll-area", ".scroll-area", 0); //原生调用js，滚动到顶部
        };
      });
      saveImage();
    }

    !this.orderNo && databus.makeVisitorFans(); //访客浏览转化成推广员的粉丝
    this.getMaterialInfo();

    if (this.fromSource) {
      YCF_Plugin.anchorPoint(
        "公众号文章",
        "official_accounts_article",
        `${getUrlParams("articleId")}-${getUrlParams("hotelId")}-${this.goodId}`
      );
    }
    YCF_Plugin.anchorPoint(
      "商品页展示",
      "gooddetail_show",
      `hotelId:${getUrlParams("hotelId")}-goodId:${this.goodId
      }-skuId:${getUrlParams("skuId")}-promotion:${getUrlParams("promotion")}`
    );
  },
  mounted: function () {
    if (
      location.hash == "#calendar" ||
      location.hash == "#productPromotion" ||
      location.hash == "#topic" ||
      location.hash == "#standard" ||
      location.hash == "#incomeStatement" ||
      location.hash == "#ruleDescription" ||
      location.hash == "#couponReceive" ||
      location.hash == "#welfareList"
    ) {
      history.go(-1);
    }
    var that = this;

    window.onhashchange = function () {
      if (!location.hash) {
        if (!that.orderNo) {
          componentCenter.topicOffer.showTopicBox &&
            componentCenter.topicOffer.slideDownTopicBox();
          componentCenter.ticketCalendar.showCalendar &&
            componentCenter.ticketCalendar.slideDownCalendar();
          componentCenter.productPromotion.showProductPromotion &&
            componentCenter.productPromotion.slideDownProductPromotion();
          componentCenter.nobrandPromotion &&
            componentCenter.nobrandPromotion.showProductPromotion &&
            componentCenter.nobrandPromotion.slideDownProductPromotion();
          componentCenter.incomeStatement.showIncomeStatement &&
            componentCenter.incomeStatement.slideDownIncomeStatement();
          componentCenter.couponReceive &&
            componentCenter.couponReceive.visible &&
            (componentCenter.couponReceive.visible = false);
          componentCenter.welfareTaskComponent &&
            componentCenter.welfareTaskComponent.isSlideUp &&
            componentCenter.welfareTaskComponent.closeWelfareList();
        }
        componentCenter.topicOffer.showRuleDescription &&
          componentCenter.topicOffer.slideDownRule();
        componentCenter.selectStandard.showSpecification &&
          componentCenter.selectStandard.slideDownSpecification();
      }
    };
    // 商品类目说明
    this.getStamps();

    // 微信授权版本取消进入页面判断授权
    // YCF_Plugin.initABTest();

    //监控会员等级弹框初次显示的事件
    componentCenter.levelChange &&
      componentCenter.levelChange.$on("showLevel", function (val) {
        that.isLevelBox = val;
      });

    //监控新人专享券弹框初次显示的事件
    componentCenter.topicOffer &&
      componentCenter.topicOffer.$refs.newComer &&
      componentCenter.topicOffer.$refs.newComer.$on(
        "coupondata",
        function (val) {
          that.isShowUserCoupon = val ? 1 : 0;
        }
      );
  },
  components: {
    StockDate,
    ComponentSelectOrderList,
    ComponentAddAppletTip,
    ComponentAppDownload,
    ComponentTopicOffer,
    ComponentCustomerService,
    ComponentSetReminder,
    ComponentTicketCalendar,
    ComponentProductPromotion,
    ComponentVideoSale,
    ComponentRelatedRecommend,
    ComponentEntranceRelatedRecommend,
    ComponentPriceOther,
    ComponentSelectStandard,
    ComponentRedpackFloat,
    ComponentTaskEntry,
    ComponentScoreAddress,
    ComponentAppPrice,
    ComponentUserEvaluation,
    ComponentFloatUp,
    ComponentShareType,
    ComponentNavigationBtn,
    ComponentOpenApp,
    ComponentNobrandPromotion,
    ComponentAutoRegister,
    ComponentEpidemicTips,
    ComponentMushList,
    ComponentUseInstruction, // 使用说明
    ComponentEnvelopeCoupon, // 红包和优惠券展示弹窗
    ComponentCouponReceive, // 红包和优惠券展示弹窗
    ComponentPackageDetail, // 套餐详情
    ComponentSameRecommend, // 同类型推荐
    ComponentCommPersonalization, // 奖励个性化展示
    ComponentPlayGuide,
    redpacketPopup,
    ComponentPreferentialInstruction,
    VideoSale, // 视频号带货弹窗
    // LiveIcon,
    'xg-player': XGPlayer,
    previewMedia,
    NoticeBar
  },
};

//规格数据处理
function standardProcessing(that) {
  if (that.couponDetail.priceAndStockNum && that.couponDetail.standardList) {
    //演出票和特产规格重复名称数据兼容
    if (that.isShowTicket || that.isSpecialty) {
      for (var typeName in that.couponDetail.standardList) {
        var standard = that.couponDetail.standardList[typeName].standard || [];
        for (var i = 0; i < standard.length; i++) {
          for (var j = i + 1; j < standard.length; j++) {
            if (standard[i].name == standard[j].name) {
              for (var k in that.couponDetail.priceAndStockNum) {
                var value = that.couponDetail.priceAndStockNum[k];
                if (typeof value.specIdKey == "string") {
                  value.specIdKey = value.specIdKey
                    .replace(standard[j].id, standard[i].id)
                    .split("_")
                    .sort(function (a, b) {
                      return a - b;
                    })
                    .join("_"); //替换重复名称的specIdKey，按id的数值从小到大排序，用_连接
                }
              }
              standard.splice(j, 1); //清除重复规格名称
              j--;
            }
          }
        }
      }
    }

    //演出票、新门票多产品集合模式数据兼容，重新赋值规格的唯一标识id
    if (that.isShowTicket || that.isMultipleDetails) {
      var newId = 1; //新规格id，替换原来的id，为了排序
      for (var typeName in that.couponDetail.standardList) {
        var standard = that.couponDetail.standardList[typeName].standard || [];
        for (var i in standard) {
          for (var j in that.couponDetail.priceAndStockNum) {
            var value = that.couponDetail.priceAndStockNum[j];
            if (typeof value.specIdKey == "string") {
              value.specIdKey = value.specIdKey
                .replace(standard[i].id, newId)
                .split("_")
                .sort(function (a, b) {
                  return a - b;
                })
                .join("_"); //更新specIdKey，按id的数值从小到大排序，用_连接
            }
          }
          standard[i].id = newId;
          newId++;
        }
      }
    }

    var standardList = {}, //临时存放改造后的that.couponDetail.standardList,standard数组改成对象,其id属性为键,加快索引
      priceAndStockNum = {}; //临时存放改造过的数据，specIdKey值当做键，加快索引速度
    for (var i in that.couponDetail.priceAndStockNum) {
      //兼容新门票多产品集合模式常规和活动状态共存的情况
      if (that.isMultipleDetails) {
        if (that.couponDetail.priceAndStockNum[i].activityId) {
          that.couponDetail.priceAndStockNum[i].price =
            that.couponDetail.priceAndStockNum[i].activityPrice;
        } else {
          that.couponDetail.priceAndStockNum[i].activityPrice =
            that.couponDetail.priceAndStockNum[i].price;
        }
      }

      if (i == 0) {
        var tempPrice =
          that.couponDetail.priceAndStockNum[i][
          that.activityId ? "activityPrice" : "price"
          ]; //第一个规格价格,用来判断是否存在多个价格
      } else if (
        !that.isMultiPrice &&
        tempPrice !=
        that.couponDetail.priceAndStockNum[i][
        that.activityId ? "activityPrice" : "price"
        ]
      ) {
        that.isMultiPrice = true;
      }
      priceAndStockNum[that.couponDetail.priceAndStockNum[i].specIdKey] = {
        activityPrice: +(
          that.couponDetail.priceAndStockNum[i].activityPrice +
          (that.couponDetail.addPrice
            ? that.couponDetail.priceAndStockNum[i].addPrice || 0
            : 0)
        ).toFixed(2),
        price: that.couponDetail.priceAndStockNum[i].price,
        skuPrice: that.couponDetail.priceAndStockNum[i].skuPrice,
        skuId: that.couponDetail.priceAndStockNum[i].skuId,
        skuName: that.couponDetail.priceAndStockNum[i].skuName,
        stockNum: +that.couponDetail.priceAndStockNum[i].stockNum,
        queueNameSec: that.couponDetail.priceAndStockNum[i].queueNameSec,
      };

      //以下属性，用在新门票多产品集合模式
      that.isMultipleDetails &&
        Object.assign(
          priceAndStockNum[that.couponDetail.priceAndStockNum[i].specIdKey],
          {
            goodId: that.couponDetail.priceAndStockNum[i].goodId,
            activityId: that.couponDetail.priceAndStockNum[i].activityId,
            goodsName: that.couponDetail.priceAndStockNum[i].goodsName,
            minNum: +that.couponDetail.priceAndStockNum[i].minNum || 1,
            maxNum: +that.couponDetail.priceAndStockNum[i].maxNum || -1,
            restrictionDetails:
              that.couponDetail.priceAndStockNum[i].restrictionDetails,
            coverPic: that.couponDetail.priceAndStockNum[i].coverPic,
          }
        );
    }

    for (var i in that.couponDetail.standardList) {
      standardList[i] = {
        typeName: that.couponDetail.standardList[i].project,
        checked: false, //对每类规格添加选中属性,默认没有
        standard: {},
      };
      for (var j in that.couponDetail.standardList[i].standard) {
        standardList[i].standard[
          that.couponDetail.standardList[i].standard[j].id
        ] = {
          id: that.couponDetail.standardList[i].standard[j].id,
          name: that.couponDetail.standardList[i].standard[j].name,
          selected: false, //对每个规格添加已选择属性,默认值false
          disabled: false, //对每个规格添加不可选属性,默认值false
        };
      }
    }

    that.priceAndStockNum = priceAndStockNum;
    that.standardList = standardList;
  } else {
    that.orderNo && $(".foot .btn-buy").addClass("disabled");
  }
}
//设置微信或app自带的图片预览功能
function setPreviewImage(that) {
  if (that.isAPP && !ykzApp.showPhotoGallery) {
    return false;
  }
  var imgUrlList = [].concat(that.albumUrl);
  if (that.couponDetail.cloudId && that.couponDetail.videoCoverUrl) {
    imgUrlList.unshift(that.couponDetail.videoCoverUrl);
  }
  $(".swiper-container .swiper-slide>img").click(function (event) {
    var imgUrl = event.target.src;
    if (typeof imgUrl != "string") {
      return false;
    } else {
      imgUrl = imgUrl.split("?")[0];
    }
    if (
      imgUrl &&
      imgUrl.search("loading_img_750_") == -1 &&
      imgUrlList.length > 0
    ) {
      that.reportUserAnchors("500097", function () {
        if (that.isAPP) {
          ykzApp.showPhotoGallery({
            photoUrls: imgUrlList,
            curIndex: (function () {
              for (var i = 0; i < imgUrlList.length; i++) {
                if (imgUrl == imgUrlList[i]) {
                  break;
                }
              }
              return i < imgUrlList.length ? i : 0;
            })(),
          });
        } else {
          previewImage({
            current: imgUrl, // 当前显示图片的http链接
            urls: imgUrlList, // 需要预览的图片http链接列表
          });
        }
      });
    }
  });
}

//Android-app,长按保存图片
function saveImage() {
  if (window.mobileEnv == "app" && isAndroid() && ykzApp.saveImage) {
    pressEvent("body", "img", (e) => {
      let src = e.target.src;
      if (src.search(/^http/) == -1) {
        //相对路径补全链接
        src = location.protocol + "//" + location.hostname + src;
      }
      ykzApp.saveImage(src);
    });
  }
}

//价格计划数据处理
function rateplanProcessing(that) {
  if (that.orderNo) return; //交易快照模式不兼容价格计划
  if (that.isRoom) return; //不兼容微客房产品
  if (that.isShowTicket) return; //不兼容演出票产品
  var pricePlan = that.couponDetail.pricePlan;
  if (!pricePlan) {
    return;
  }
  if (
    !pricePlan.data ||
    !pricePlan.data.length ||
    (that.isEntranceTicket && that.couponDetail.changeCalendar == 1)
  ) {
    if (that.rateplan) {
      that.isExpired = true;
      that.isOnline = false;
    }
    return;
  }
  that.isRateplan = true;
  var priceAndStockNum = that.couponDetail.priceAndStockNum;
  if (that.rateplan) {
    //指定价格计划
    that.useCoupon =
      typeof pricePlan.data[0].useCoupon != "undefined"
        ? pricePlan.data[0].useCoupon
        : 1;
    that.useCloudCoin =
      typeof pricePlan.data[0].useCloudCoin != "undefined"
        ? pricePlan.data[0].useCloudCoin
        : 1;
    pricePlan.data[0].isLimit == 0 &&
      (that.couponDetail.restrictionDetails = "");
    if (
      !pricePlan.data[0].priceSkuData ||
      !pricePlan.data[0].priceSkuData.length
    ) {
      return;
    }
    if (!priceAndStockNum || !that.couponDetail.standardList) {
      if (
        that.isEntranceTicket &&
        pricePlan.data[0].operator &&
        pricePlan.data[0].operator.operator &&
        typeof pricePlan.data[0].operator.num == "number"
      ) {
        //日历和直采门票，特殊处理
        if (pricePlan.data[0].operator.operator == "+") {
          that.couponDetail[that.activityId ? "activityPrice" : "sellPrice"] +=
            pricePlan.data[0].operator.num;
        } else if (pricePlan.data[0].operator.operator == "-") {
          that.couponDetail[that.activityId ? "activityPrice" : "sellPrice"] -=
            pricePlan.data[0].operator.num;
        } else if (pricePlan.data[0].operator.operator == "*") {
          that.couponDetail[that.activityId ? "activityPrice" : "sellPrice"] *=
            pricePlan.data[0].operator.num / 100;
        } else {
          console.log("返回未定义的运算符了！");
        }
        that.couponDetail[that.activityId ? "activityPrice" : "sellPrice"] =
          Math.round(
            that.couponDetail[that.activityId ? "activityPrice" : "sellPrice"] *
            100
          ) / 100;
        if (
          that.couponDetail[that.activityId ? "activityPrice" : "sellPrice"] <
          0.01
        ) {
          that.couponDetail[
            that.activityId ? "activityPrice" : "sellPrice"
          ] = 0.01;
          that.isExpired = true;
          that.isOnline = false;
        }
      } else {
        that.couponDetail[that.activityId ? "activityPrice" : "sellPrice"] =
          pricePlan.data[0].priceSkuData[0].price;
      }
      if (pricePlan.data[0].setStock) {
        if (
          that.couponDetail.stockNum > pricePlan.data[0].priceSkuData[0].stock
        ) {
          that.couponDetail.stockNum = pricePlan.data[0].priceSkuData[0].stock;
        }
      } else {
        if (pricePlan.data[0].priceSkuData[0].otherStock) {
          that.couponDetail.stockNum -=
            pricePlan.data[0].priceSkuData[0].otherStock;
        }
      }
    } else {
      for (var i = 0; i < pricePlan.data[0].priceSkuData.length; i++) {
        for (var j = 0; j < priceAndStockNum.length; j++) {
          if (
            priceAndStockNum[j].skuId == pricePlan.data[0].priceSkuData[i].skuId
          ) {
            if (pricePlan.data[0].setStock) {
              if (
                priceAndStockNum[j].stockNum >
                pricePlan.data[0].priceSkuData[i].stock
              ) {
                priceAndStockNum[j].stockNum =
                  pricePlan.data[0].priceSkuData[i].stock;
              }
            } else {
              if (pricePlan.data[0].priceSkuData[i].otherStock) {
                priceAndStockNum[j].stockNum -=
                  pricePlan.data[0].priceSkuData[i].otherStock;
                priceAndStockNum[j].stockNum < 0 &&
                  (priceAndStockNum[j].stockNum = 0);
              }
            }
            priceAndStockNum[j][that.activityId ? "activityPrice" : "price"] =
              pricePlan.data[0].priceSkuData[i].price;
            break;
          }
        }
      }
      var minPrice =
        priceAndStockNum[0][that.activityId ? "activityPrice" : "price"];
      that.couponDetail.stockNum = 0;
      for (var i = 0; i < priceAndStockNum.length; i++) {
        if (
          minPrice >
          priceAndStockNum[i][that.activityId ? "activityPrice" : "price"]
        ) {
          minPrice =
            priceAndStockNum[i][that.activityId ? "activityPrice" : "price"];
        }
        that.couponDetail.stockNum += priceAndStockNum[i].stockNum;
      }
      that.couponDetail[that.activityId ? "activityPrice" : "sellPrice"] =
        minPrice;
    }
  } else {
    //未指定价格计划
    if (!priceAndStockNum || !that.couponDetail.standardList) {
      for (var i = 0; i < pricePlan.data.length; i++) {
        if (pricePlan.data[i].setStock) {
          that.couponDetail.stockNum -= pricePlan.data[i].priceSkuData[0].stock;
        }
      }
    } else {
      for (var i = 0; i < pricePlan.data.length; i++) {
        if (pricePlan.data[i].setStock) {
          for (var j = 0; j < pricePlan.data[i].priceSkuData.length; j++) {
            for (var k = 0; k < priceAndStockNum.length; k++) {
              if (
                priceAndStockNum[k].skuId ==
                pricePlan.data[i].priceSkuData[j].skuId
              ) {
                priceAndStockNum[k].stockNum -=
                  pricePlan.data[i].priceSkuData[j].stock;
                priceAndStockNum[k].stockNum < 0 &&
                  (priceAndStockNum[k].stockNum = 0);
                break;
              }
            }
          }
        }
      }
      that.couponDetail.stockNum = 0;
      for (var i = 0; i < priceAndStockNum.length; i++) {
        that.couponDetail.stockNum += priceAndStockNum[i].stockNum;
      }
    }
  }
  if (that.couponDetail.stockNum <= 0) {
    that.couponDetail.stockNum = 0;
    that.couponDetail.stockShow = 2;
  }
}

export default page;
